
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("a5txT", function(module, exports) {

var $7xVCs = parcelRequire("7xVCs");

const $82982cff56793d8b$var$standalonePageTreeStateUpdater = new (0, $7xVCs.PageTreeStateUpdater)();
const $82982cff56793d8b$export$19e3952b1a66ecb = ()=>$82982cff56793d8b$var$standalonePageTreeStateUpdater;
module.exports["getStandalonePageTreeStateUpdater"] = $82982cff56793d8b$export$19e3952b1a66ecb;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("30qWc", function(module, exports) {

var $308Wd = parcelRequire("308Wd");

function $9acca7871dfd8a5c$export$a59d7e865b63a081({ children: children, mutation: mutation, ...props }) {
    const mutationTuple = (0, $308Wd.useMutationInterop)(mutation, props);
    return children(...mutationTuple);
}
module.exports["MutationInterop"] = $9acca7871dfd8a5c$export$a59d7e865b63a081;

});

parcelRegister("b1HmN", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ishvT",
    name: "LoadableChangeEditionNotificationDialog",
    loader: async ()=>(await (parcelRequire("5qaUe"))).ChangeEditionNotificationDialog
});
module.exports["LoadableChangeEditionNotificationDialog"] = $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6;

});

parcelRegister("5qaUe", function(module, exports) {

let $3f27d7256274f21c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3f27d7256274f21c$var$load("kSVGa").then(()=>parcelRequire('5BDEU'));

});

parcelRegister("hDG7z", function(module, exports) {
//this file switches between Nav 3 and Nav 4 page-layout components. When Nav 4 is at 100% this file can simply be deleted and index can export nav 4 directly instead

var $42omo = parcelRequire("42omo");


var $gz8ZY = parcelRequire("gz8ZY");


var $cgEsw = parcelRequire("cgEsw");


var $jbuqY = parcelRequire("jbuqY");

const $c8aadc7c03a52230$export$6d1402fb58384e4f = (props)=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    return isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgEsw.Nav4Layout), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jbuqY.Nav3Layout), props);
};
module.exports["PageLayout"] = $c8aadc7c03a52230$export$6d1402fb58384e4f;

});

parcelRegister("cgEsw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $acf3be568142fa4d$export$25b68ac96f2af713 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Y6119",
    name: "Nav4Layout",
    loader: async ()=>(await (parcelRequire("2Y1wO"))).PageLayout
});
module.exports["Nav4Layout"] = $acf3be568142fa4d$export$25b68ac96f2af713;

});

parcelRegister("2Y1wO", function(module, exports) {

let $22925ed5c9b68e70$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $22925ed5c9b68e70$var$load("4lSDd"),
    $22925ed5c9b68e70$var$load("6AiL8"),
    $22925ed5c9b68e70$var$load("8JZKd"),
    $22925ed5c9b68e70$var$load("jzQa8"),
    $22925ed5c9b68e70$var$load("d2ioG"),
    $22925ed5c9b68e70$var$load("hLrnF"),
    $22925ed5c9b68e70$var$load("3rFQl"),
    $22925ed5c9b68e70$var$load("3Kg3S"),
    $22925ed5c9b68e70$var$load("88qM1"),
    $22925ed5c9b68e70$var$load("iHvjC"),
    $22925ed5c9b68e70$var$load("dPH9c"),
    $22925ed5c9b68e70$var$load("7MnLd"),
    $22925ed5c9b68e70$var$load("Z6x4Y"),
    $22925ed5c9b68e70$var$load("8H49b"),
    $22925ed5c9b68e70$var$load("31zRr"),
    $22925ed5c9b68e70$var$load("dEcOC"),
    $22925ed5c9b68e70$var$load("aZinD"),
    $22925ed5c9b68e70$var$load("2tSa5"),
    $22925ed5c9b68e70$var$load("jvHRs"),
    $22925ed5c9b68e70$var$load("kqWUF"),
    $22925ed5c9b68e70$var$load("9L8th"),
    $22925ed5c9b68e70$var$load("fkD5j"),
    $22925ed5c9b68e70$var$load("5i0u2"),
    $22925ed5c9b68e70$var$load("jcby2"),
    $22925ed5c9b68e70$var$load("cpDT3"),
    $22925ed5c9b68e70$var$load("6JMIx"),
    $22925ed5c9b68e70$var$load("lxJNk"),
    $22925ed5c9b68e70$var$load("8c4Ih"),
    $22925ed5c9b68e70$var$load("gYTHw"),
    $22925ed5c9b68e70$var$load("19D1M"),
    $22925ed5c9b68e70$var$load("2272L"),
    $22925ed5c9b68e70$var$load("aeEUI"),
    $22925ed5c9b68e70$var$load("iXzmH"),
    $22925ed5c9b68e70$var$load("65c4i"),
    $22925ed5c9b68e70$var$load("kjZZD"),
    $22925ed5c9b68e70$var$load("5fSdR"),
    $22925ed5c9b68e70$var$load("lvjx6"),
    $22925ed5c9b68e70$var$load("6wr18"),
    $22925ed5c9b68e70$var$load("cyGuT"),
    $22925ed5c9b68e70$var$load("kDPsc"),
    $22925ed5c9b68e70$var$load("gaYsU"),
    $22925ed5c9b68e70$var$load("X678k"),
    $22925ed5c9b68e70$var$load("6vEb6"),
    $22925ed5c9b68e70$var$load("kbLtt"),
    $22925ed5c9b68e70$var$load("54Aje"),
    $22925ed5c9b68e70$var$load("gGCYy"),
    $22925ed5c9b68e70$var$load("fO3hx"),
    $22925ed5c9b68e70$var$load("2rxez"),
    $22925ed5c9b68e70$var$load("l4lEp"),
    $22925ed5c9b68e70$var$load("hhss7"),
    $22925ed5c9b68e70$var$load("ffEVr"),
    $22925ed5c9b68e70$var$load("Wowvf"),
    $22925ed5c9b68e70$var$load("iQDXb"),
    $22925ed5c9b68e70$var$load("7EorR"),
    $22925ed5c9b68e70$var$load("kYzDf"),
    $22925ed5c9b68e70$var$load("9O0VQ"),
    $22925ed5c9b68e70$var$load("ciAVN"),
    $22925ed5c9b68e70$var$load("l9qI6"),
    $22925ed5c9b68e70$var$load("lUL2G"),
    $22925ed5c9b68e70$var$load("gmHzx")
]).then(()=>parcelRequire('48Eol'));

});

parcelRegister("jbuqY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f6f90fb0ae36f35f$export$7faac1b59c375dfa = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oUMKP",
    name: "Nav3Layout",
    loader: async ()=>(await (parcelRequire("x8nit"))).PageLayout
});
module.exports["Nav3Layout"] = $f6f90fb0ae36f35f$export$7faac1b59c375dfa;

});

parcelRegister("x8nit", function(module, exports) {

let $0639943c0e2d46cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0639943c0e2d46cc$var$load("6wr18"),
    $0639943c0e2d46cc$var$load("jLbdY"),
    $0639943c0e2d46cc$var$load("b8HYR"),
    $0639943c0e2d46cc$var$load("2F69B"),
    $0639943c0e2d46cc$var$load("8sIhy"),
    $0639943c0e2d46cc$var$load("6JMIx"),
    $0639943c0e2d46cc$var$load("7EorR"),
    $0639943c0e2d46cc$var$load("ffEVr"),
    $0639943c0e2d46cc$var$load("hhss7"),
    $0639943c0e2d46cc$var$load("a6eof")
]).then(()=>parcelRequire('2xpE0'));

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("fIdAJ"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("fIdAJ", function(module, exports) {

let $b7058211b83db610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7058211b83db610$var$load("kyxdN").then(()=>parcelRequire('asonV'));

});

parcelRegister("ezLwY", function(module, exports) {
parcelRequire("cEgln");
var $3IK76 = parcelRequire("3IK76");


var $cpjd2 = parcelRequire("cpjd2");

const $a9c9343047c8f651$var$contexts = {};
const $a9c9343047c8f651$var$runSafely = (fn)=>{
    try {
        fn();
    } catch (e) {
        // TODO: find a real fix for this issue HOT-82965 | CONFCLOUD-58951
        console.error(e);
    }
};
const $a9c9343047c8f651$export$2cd8252107eb640b = ()=>{
    (0, $cpjd2.requireLegacyWRM)([
        'wrc!confluence-keyboard-shortcuts-batch'
    ], ()=>{
        $a9c9343047c8f651$var$runSafely(()=>{
            (0, $3IK76.bind)('register-contexts.keyboardshortcuts', (e, data)=>{
                const { enableContext: enableContext } = data.shortcutRegistry;
                Object.entries($a9c9343047c8f651$var$contexts).forEach(([context, enabled])=>{
                    if (enabled) enableContext(context);
                });
            });
            (0, $3IK76.trigger)('initialize.keyboardshortcuts');
        });
    }, ()=>{});
};
const $a9c9343047c8f651$export$e758fd0259c79269 = ()=>{
    // We need to disable all shortcuts and enable again
    // the ones still available as the currrent library doesn't expose a
    // method for removing just one context and we want to keep previous
    // added contexts alive
    $a9c9343047c8f651$var$runSafely(()=>{
        (0, $3IK76.trigger)('remove-bindings.keyboardshortcuts');
        (0, $3IK76.trigger)('initialize.keyboardshortcuts');
    });
};
const $a9c9343047c8f651$var$makeSetContext = (enable)=>(newContexts)=>{
        if (!Array.isArray(newContexts)) newContexts = [
            newContexts
        ];
        newContexts.forEach((context)=>{
            if ($a9c9343047c8f651$var$contexts[context] !== enable) {
                $a9c9343047c8f651$var$contexts[context] = enable;
                $a9c9343047c8f651$export$e758fd0259c79269();
            }
        });
    };
const $a9c9343047c8f651$export$2ca78a0e32b5ba4e = $a9c9343047c8f651$var$makeSetContext(true);
const $a9c9343047c8f651$export$48a00fd3a2cf40e0 = $a9c9343047c8f651$var$makeSetContext(false);
const $a9c9343047c8f651$export$4794d9b1949031cf = ()=>{
    $a9c9343047c8f651$var$runSafely(()=>{
        (0, $3IK76.trigger)('remove-bindings.keyboardshortcuts');
    });
};
module.exports["init"] = $a9c9343047c8f651$export$2cd8252107eb640b;
module.exports["enableContext"] = $a9c9343047c8f651$export$2ca78a0e32b5ba4e;
module.exports["disableContext"] = $a9c9343047c8f651$export$48a00fd3a2cf40e0;
module.exports["teardown"] = $a9c9343047c8f651$export$4794d9b1949031cf;

});

parcelRegister("cEgln", function(module, exports) {
$parcel$export(module.exports, "trigger", () => (parcelRequire("3IK76")).trigger);
$parcel$export(module.exports, "bind", () => (parcelRequire("3IK76")).bind);
$parcel$export(module.exports, "unbind", () => (parcelRequire("3IK76")).unbind);

var $3IK76 = parcelRequire("3IK76");


});

parcelRegister("3IK76", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");


var $jnN7b = parcelRequire("jnN7b");

function $2b59405ae3db7385$export$2385a24977818dd0(eventType, eventData, handler) {
    if (typeof handler === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).bind(eventType, eventData, handler);
    else return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).bind(eventType, eventData);
}
function $2b59405ae3db7385$export$433e98592e7124fd(eventType, handler) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).unbind(eventType, handler);
}
function $2b59405ae3db7385$export$e614dc9140f7ae71(eventType, extraParameters) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).trigger(eventType, extraParameters);
}
module.exports["bind"] = $2b59405ae3db7385$export$2385a24977818dd0;
module.exports["unbind"] = $2b59405ae3db7385$export$433e98592e7124fd;
module.exports["trigger"] = $2b59405ae3db7385$export$e614dc9140f7ae71;

});

parcelRegister("jnN7b", function(module, exports) {
module.exports = jQuery;

});

parcelRegister("fmuCC", function(module, exports) {

let $b2f0a9f0e00b7e22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b2f0a9f0e00b7e22$var$load("lgm1i").then(()=>parcelRequire('04Nru'));

});

parcelRegister("jzEl8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $9HkI0 = parcelRequire("9HkI0");

const $6cbcb1ce2cb81a03$var$REPLACED_MARKER = 'data-replaced';
const $6cbcb1ce2cb81a03$var$CLONE_MARKER = 'data-clone';
class $6cbcb1ce2cb81a03$export$a1d3010d20ec2131 extends (0, $42omo.PureComponent) {
    getLegacyElements() {
        const { rootNode: rootNode = window.document, selectors: selectors = [] } = this.props;
        if (!rootNode) return [];
        return Array.from(rootNode.querySelectorAll(selectors.join(',')));
    }
    getDomElementAttrsMap(domElement) {
        if (!domElement.hasAttributes()) return {};
        return Object.values(domElement.attributes).reduce((acc, attr)=>{
            acc[attr.name] = attr.value;
            return acc;
        }, {});
    }
    replaceDOMElementsWithPortal() {
        const { deleteExistingContent: deleteExistingContent, replacePlaceholderWith: replacePlaceholderWith, portalNode: portalNode } = this.props;
        this.workerInProgress = true;
        this.getLegacyElements().forEach((node)=>{
            const currentNodeAttrs = this.getDomElementAttrsMap(node);
            if (currentNodeAttrs[$6cbcb1ce2cb81a03$var$REPLACED_MARKER] || currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER]) return; // do not clone clones or already cloned nodes
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            node.setAttribute($6cbcb1ce2cb81a03$var$REPLACED_MARKER, true);
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER] = true;
            currentNodeAttrs['key'] = currentNodeAttrs.id || (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
            let targetNode = node;
            if (replacePlaceholderWith) {
                targetNode = window.document.createElement(replacePlaceholderWith.elementName);
                const attributes = replacePlaceholderWith.attributes || {};
                for(const attr in attributes)targetNode.setAttribute(attr, attributes[attr]);
                node.parentNode.replaceChild(targetNode, node);
            }
            if (deleteExistingContent) while(targetNode.firstChild)targetNode.removeChild(targetNode.firstChild);
            if (portalNode) {
                const reactEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(portalNode, currentNodeAttrs);
                this.portals.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(reactEl, targetNode));
            }
        });
        const attemptsLeft = this.state.attemptsLeft - 1;
        this.setState({
            attemptsLeft: attemptsLeft
        });
        if (attemptsLeft > 0) window.setTimeout(()=>{
            this.replaceDOMElementsWithPortal();
        }, this.props.retryDelay);
        else this.workerInProgress = false;
    }
    render() {
        if (this.state.attemptsLeft > 0 && !this.workerInProgress) setTimeout(()=>{
            this.replaceDOMElementsWithPortal();
        }, 0);
        return this.portals.map((item)=>item);
    }
    constructor(...args){
        super(...args);
        this.state = {
            attemptsLeft: this.props.attempts ?? 0
        };
        this.workerInProgress = false;
        this.portals = [];
    }
}
$6cbcb1ce2cb81a03$export$a1d3010d20ec2131.defaultProps = {
    attempts: 1,
    retryDelay: 50,
    deleteExistingContent: true
};
module.exports["LegacyDOMBridge"] = $6cbcb1ce2cb81a03$export$a1d3010d20ec2131;

});

parcelRegister("7CN7P", function(module, exports) {

let $58d2304715e30f91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $58d2304715e30f91$var$load("6wr18"),
    $58d2304715e30f91$var$load("j06N4"),
    $58d2304715e30f91$var$load("ffEVr"),
    $58d2304715e30f91$var$load("Wowvf"),
    $58d2304715e30f91$var$load("lwfE5")
]).then(()=>parcelRequire('MkVVm'));

});

parcelRegister("3Husr", function(module, exports) {

let $2b1d03858eb450ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2b1d03858eb450ba$var$load("6wr18"),
    $2b1d03858eb450ba$var$load("ffEVr"),
    $2b1d03858eb450ba$var$load("Wowvf"),
    $2b1d03858eb450ba$var$load("d7sp9")
]).then(()=>parcelRequire('4Au5p'));

});

parcelRegister("7WvNl", function(module, exports) {

let $5c869cfa0ccf61cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5c869cfa0ccf61cf$var$load("6wr18"),
    $5c869cfa0ccf61cf$var$load("jzhuW"),
    $5c869cfa0ccf61cf$var$load("ffEVr"),
    $5c869cfa0ccf61cf$var$load("Wowvf"),
    $5c869cfa0ccf61cf$var$load("c8zt5")
]).then(()=>parcelRequire('9krjM'));

});

parcelRegister("9GEwo", function(module, exports) {

let $70d7780217589f5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70d7780217589f5b$var$load("ei0Jg").then(()=>parcelRequire('esrJ1'));

});

parcelRegister("7nmkU", function(module, exports) {

let $55ec01e1fb53735b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55ec01e1fb53735b$var$load("hhf8b").then(()=>parcelRequire('cDa2P'));

});

parcelRegister("ax8Zf", function(module, exports) {

let $7ab3f50d85b48d99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7ab3f50d85b48d99$var$load("82QsP"),
    $7ab3f50d85b48d99$var$load("an2zh")
]).then(()=>parcelRequire('3Fqft'));

});

parcelRegister("d1Pi6", function(module, exports) {

let $97c327a8a6cb8f32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $97c327a8a6cb8f32$var$load("82QsP"),
    $97c327a8a6cb8f32$var$load("gJRFC")
]).then(()=>parcelRequire('bQl5d'));

});

parcelRegister("14QAi", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");

var $flE5X = parcelRequire("flE5X");


var $lzcvT = parcelRequire("lzcvT");

const $1ce5a19013c572e5$export$4a6cb1fe56895a84 = {
    federal: {
        staging: 'https://fed-support-gateway.us-east-1.staging.atl-paas-us-gov-mod.net',
        production: 'https://fed-support-gateway.us-east-1.prod.atl-paas-us-gov-mod.net'
    }
};
const $1ce5a19013c572e5$export$529433b0a9e66822 = (url, isFedrampEnv, environment)=>{
    const isFedrampEnvironment = isFedrampEnv ?? (0, $lzcvT.isFedRamp)();
    if (isFedrampEnvironment) {
        // Auto-detect environment based on hostname patterns
        const env = environment ?? (()=>{
            const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
            // Check for staging patterns in hostname
            return hostname.includes('stg') || hostname.includes('staging') ? 'staging' : 'production';
        })();
        const baseUrl = $1ce5a19013c572e5$export$4a6cb1fe56895a84.federal[env];
        return `${baseUrl}${url}`;
    }
    // For non-FedRAMP environments, use relative URLs (current behavior)
    return url;
};
// ANALYTICS PROPERTIES
const $1ce5a19013c572e5$var$SPACE_OVERVIEW = 'spaceSettings/overview';
const $1ce5a19013c572e5$var$SPACE_PERMISSIONS = 'spaceSettings/permissions';
const $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS = 'spaceSettings/contentTools';
const $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL = 'spaceSettings/lookAndFeel';
const $1ce5a19013c572e5$var$SPACE_INTEGRATIONS = 'spaceSettings/Integrations';
// ROUTE GROUPS
const $1ce5a19013c572e5$var$SPACE_SETTINGS = 'space-settings';
const $1ce5a19013c572e5$export$244e5242c65921be = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice#13.-Additional-Disclosures-for-California-Residents';
const $1ce5a19013c572e5$export$ab8f8977c5e363cb = 'https://www.atlassian.com/legal/privacy-policy#additional-disclosures-for-ca-residents';
const $1ce5a19013c572e5$export$86f8e0fbd7845b32 = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice';
const $1ce5a19013c572e5$export$87259143062a27ea = 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers';
const $1ce5a19013c572e5$export$108231643dc5e01e = [
    'Online Help',
    'Get the mobile app',
    'Feed Builder',
    'Keyboard Shortcuts',
    'Site Status',
    "What\u2019s new",
    'About Confluence'
];
const $1ce5a19013c572e5$export$40e045b7d0d057fd = (route)=>{
    // get what route we're on by switching based on
    // the regex evaluating to true
    switch(true){
        /**
		 * SPACE SETTINGS - OVERVIEW
		 */ case /viewspacesummary/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-details',
                articleId: '2ngx6W7OSkTdvFP6m1jdYC',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'spaceDetailsScreen'
            };
        case /archivespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /archiveSpace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /editFeatures/.test(route):
            return {
                routeName: 'edit-sidebar',
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                articleId: '6ivofSJlfSXa9IASo00kvA',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'sidebarConfigurationScreen'
            };
        case /removespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'delete-space',
                articleId: '7edCGN0nkqsvUd9s3AzEq8',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'deleteSpaceScreen'
            };
        /**
		 * SPACE SETTINGS - PERMISSIONS
		 */ case /spaces\/.*\/settings\/permissions\/\d*/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /spacepermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /addonpermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'addOnScreen'
            };
        case /listpermissionpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'page-restrictions',
                articleId: '7f9j14trnF75aeuihHAoLp',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'restrictedPagesScreen'
            };
        case /reorderpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'reorder-pages',
                articleId: '5faOvjH2hAw2CpZY3tC3ej',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'reorderPagesScreen'
            };
        case /listorphanedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'orphaned-pages',
                articleId: '1mxG2f1dvIifiDqKrkvy98',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'orphanedPagesScreen'
            };
        case /listundefinedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined-pages',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'undefinedPagesScreen'
            };
        case /listattachmentsforspace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'attachments',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'attachmentsScreen'
            };
        case /viewtrash/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'trash',
                articleId: '6NL5cRC6aV7k9ucd2yEZzZ',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'trashScreen'
            };
        case /exportspacewelcome/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'export-space',
                articleId: '6RcXthpHKQasH09gERDkE8',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'exportScreen'
            };
        case /listrssfeeds/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'rss-feed',
                articleId: '6TyTkhaowcNTwvq9V0rt10',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'rssFeedsScreen'
            };
        /**
		 * SPACE SETTINGS - LOOK AND FEEL
		 */ case /spaces\/choosetheme/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'themes',
                articleId: '3Owkyfl2mshKQQ2mECCV8q',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'themesScreen'
            };
        case /custompagecontent/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'header-and-footer',
                articleId: '2i2NAHbTjkWeoprrdWlNX',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'headerAndFooterScreen'
            };
        case /viewpdfconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfConfigScreen'
            };
        case /viewpdflayoutconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfLayoutScreen'
            };
        case /viewpdfstyleconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfStylesheetScreen'
            };
        /**
		 * SPACE SETTINGS - INTEGRATIONS
		 */ case /listentitylinks/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_INTEGRATIONS,
                screen: 'applicationLinksScreen'
            };
        /**
		 * CONNECT ADDONS
		 */ case /analytics\/permissions/.test(route):
            return {
                routeGroup: 'site-settings',
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /atlassian-connect\/space-tools-tab.action/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'analyticsPermissionsScreen'
            };
        /**
		 * CONTENT TYPE VIEW PAGES
		 */ case /spaces\/.*\/pages\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-page',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/whiteboard\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-whiteboard',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/database\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-database',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/embed\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-embed',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/calendars/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-calendars',
                articleId: '85KAXe75f9VdMibJa5FHz',
                section: 'notTracked',
                screen: 'notTracked'
            };
        /**
		 * EVERYTHING ELSE
		 */ default:
            return {
                routeGroup: 'undefined',
                articleId: '',
                section: 'notTracked',
                routeName: 'undefined',
                screen: 'notTracked'
            };
    }
};
const $1ce5a19013c572e5$export$c28bcc688252a1b6 = (error)=>{
    return [
        'algolia',
        'unreachable hosts'
    ].some((err)=>error.message.toLowerCase().includes(err)) || error instanceof (0, $flE5X.NoNetworkError) || error instanceof (0, $hBkCm.BadStatusError) && error.response.status >= 500;
};
module.exports["getFedSupportGatewayURL"] = $1ce5a19013c572e5$export$529433b0a9e66822;
module.exports["INTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$244e5242c65921be;
module.exports["EXTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$ab8f8977c5e363cb;
module.exports["INTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$86f8e0fbd7845b32;
module.exports["EXTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$87259143062a27ea;
module.exports["FILTERED_MENU_ITEMS"] = $1ce5a19013c572e5$export$108231643dc5e01e;
module.exports["getRouteData"] = $1ce5a19013c572e5$export$40e045b7d0d057fd;
module.exports["isSearchProviderUnreachableError"] = $1ce5a19013c572e5$export$c28bcc688252a1b6;

});

$parcel$global.rwr("3pblT", () => { var $641b1c6217a990fa$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"3pblT\",\"standalone-navigation-jquery3.ce82357f.js\",\"kSVGa\",\"ChangeEditionNotificationDialog.ce391398.js\",\"gmHzx\",\"PageLayout.8e35b2a9.js\",\"5joXW\",\"GuestRequestToUpgradeToUser.e0cbbeab.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.2f5a8345.js\",\"1epse\",\"GuestRequestToUpgradeLearnMoreModal.9586fbc9.js\",\"8Txex\",\"Guest-Avatar.ebdf69f1.svg\",\"2wyTK\",\"Team-Avatars.4f1b07ad.svg\",\"3wN5D\",\"ExternalSpaceLozenge.de41bba8.js\",\"j3iEF\",\"CommentAddPromptNudgeText.0d3c71f9.js\",\"lwUFR\",\"RequestAccessForUnassignedGuest.9ee8cb83.js\",\"aad5M\",\"Collaboration-Bike.8735a1c6.svg\",\"7Ni3R\",\"GuestOnboardingModal.728c330e.js\",\"WYAWv\",\"Guest-Onboarding-Light.8e788fbd.svg\",\"4rpM2\",\"Guest-Onboarding-Dark.f055cab3.svg\",\"kpHRm\",\"GeneralShortcutListener.4a3a882f.js\",\"6JMIx\",\"GeneralShortcutListener.97052f75.js\",\"6KGrg\",\"EmojiComponent.638705b6.js\",\"ffEVr\",\"vendors~editor_icon.baa31d73.js\",\"kjZZD\",\"vendors~editor_icon-object.7558c7c4.js\",\"ffEVr\",\"vendors~editor_icon.baa31d73.js\",\"6wr18\",\"vendors~editor_icon.52445d34.js\",\"6wr18\",\"vendors~editor_icon.52445d34.js\",\"1lvsb\",\"EmojiTitlePopover.88668ad7.js\",\"9Zd2C\",\"EmojiTitleButton.55a4babe.js\",\"XgRtr\",\"EmojiPicker.642be1ec.js\",\"2F69B\",\"vendors~small-pkgs.c7a7ae77.js\",\"4hZJd\",\"EmojiTitleSelection.7e858029.js\",\"hUvv7\",\"LiveDocsDefaultIcon.2ebfeac5.js\",\"aoJPa\",\"main.af6b8d22.js\",\"2tjCd\",\"main.8ddf5a50.js\",\"koKgZ\",\"datasourceRenderFailedAnalyticsWrapper.0e5220a8.js\",\"7ixUU\",\"datasourceTableView.d457bc6b.js\",\"6cVEd\",\"fire-event.c34a04c0.js\",\"l4lEp\",\"ErrorComponent.aab088d3.js\",\"2rxez\",\"ErrorComponent.runtime.0a0ee09f.js\",\"2rxez\",\"ErrorComponent.runtime.0a0ee09f.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.e5b3806d.js\",\"kHOMt\",\"manual-triggers-modal.ac3155e2.js\",\"7EorR\",\"vendors~editor_atlaskit_md.7204649c.js\",\"aZ4rV\",\"datasourceTableView.dff6b341.js\",\"7fMGd\",\"dark.16cc06e7.svg\",\"8OP1c\",\"light.e350f7db.svg\",\"gywm1\",\"dark.981334ac.svg\",\"29by2\",\"light.d61b1f64.svg\",\"XXMwE\",\"dark.90199792.svg\",\"cqbvn\",\"light.5ffcf568.svg\",\"bEo2Z\",\"standard.6c3cc6ed.svg\",\"65c4i\",\"datasourceTableView.34597e8f.js\",\"iXzmH\",\"datasourceTableView.runtime.607dda84.js\",\"8makw\",\"datasourceTableView.851020c6.js\",\"cwpgX\",\"datasourceTableView.8d80f86b.js\",\"gxkWc\",\"chevron-up.0e24c8c4.js\",\"8JZKd\",\"activity.7479de1f.js\",\"jBtK5\",\"refresh.cc141204.js\",\"5fSdR\",\"manual-triggers-modal.03c2c8a8.js\",\"iXzmH\",\"datasourceTableView.runtime.607dda84.js\",\"hoPZ9\",\"cs.2ad5de4f.js\",\"bv8GZ\",\"cs.b8d1c1b1.js\",\"i5eMd\",\"cs.e46cc0f9.js\",\"1jsQH\",\"cs.688247af.js\",\"2Fu3d\",\"da.1d089a01.js\",\"cdeuH\",\"da.42823f82.js\",\"4UPfH\",\"da.7cd44a10.js\",\"deyvi\",\"da.ce01a3f4.js\",\"eJgH8\",\"de.6182bf8c.js\",\"7gF8f\",\"de.8842c040.js\",\"gd4qs\",\"de.aff4c831.js\",\"6dERU\",\"de.196d0286.js\",\"2YffH\",\"en.857c7bef.js\",\"7Lkvk\",\"en_GB.1d1eb83c.js\",\"djb49\",\"en-GB.70cd0dcf.js\",\"fviv5\",\"en-GB.7ddc4d94.js\",\"kTurq\",\"en-GB.2a18e6c6.js\",\"5FaEJ\",\"en_ZZ.7773d456.js\",\"ksTQ6\",\"en-ZZ.4f7eefe8.js\",\"eBoC7\",\"en-ZZ.5cdcae98.js\",\"j0PWv\",\"en-ZZ.b5f22d6a.js\",\"9yemY\",\"es.e64e394c.js\",\"5CGnz\",\"es.98f8e90e.js\",\"bNv64\",\"es.6f56d6cf.js\",\"dlmud\",\"es.a37dad44.js\",\"5IaSN\",\"et.44097a09.js\",\"X0Jic\",\"et.155c1ee0.js\",\"bAoKR\",\"et.b46b672c.js\",\"7snhF\",\"et.20d4d799.js\",\"l2LZP\",\"fi.17f2bc8c.js\",\"9Oxgj\",\"fi.f2f3389c.js\",\"4Afgd\",\"fi.090596b4.js\",\"cbkj0\",\"fi.c129a5d2.js\",\"35Ssm\",\"fr.6d303a8e.js\",\"kAg8V\",\"fr.368a32d8.js\",\"cMubu\",\"fr.3646533d.js\",\"17m16\",\"fr.d48d2214.js\",\"ik6u5\",\"hu.3892d157.js\",\"fM2oh\",\"hu.f2f9ae82.js\",\"3fLE9\",\"hu.58b2a38f.js\",\"b4NO6\",\"hu.d63219d9.js\",\"fModo\",\"is.ef98b365.js\",\"Vt6S9\",\"it.6c514ac7.js\",\"xnqy2\",\"it.351ab003.js\",\"8hOn0\",\"it.8eeb6c3a.js\",\"1K1Fj\",\"it.68b18a63.js\",\"9GZ76\",\"ja.12dc9317.js\",\"awkVi\",\"ja.99d2f833.js\",\"h4OCL\",\"ja.976ed2ac.js\",\"38sfA\",\"ja.05e83d89.js\",\"4sOIV\",\"ko.d87d06e1.js\",\"11DLa\",\"ko.8aeaf96b.js\",\"bcQs2\",\"ko.b847baaa.js\",\"bjmre\",\"ko.5d08c8ec.js\",\"QTjdE\",\"nb.6e0b1e09.js\",\"barSq\",\"nb.4503e9a5.js\",\"aBa7j\",\"nb.df917f91.js\",\"asvK9\",\"nb.b60c8cb7.js\",\"hrf1M\",\"nl.a72a118a.js\",\"a8heY\",\"nl.6070b16e.js\",\"b544F\",\"nl.423010d9.js\",\"7v6wU\",\"nl.d417f24d.js\",\"lsloj\",\"pl.0f528837.js\",\"6hlNE\",\"pl.9a5b0b0f.js\",\"K6fhx\",\"pl.5e997368.js\",\"aEpRh\",\"pl.26cf010d.js\",\"iRKhU\",\"pt_BR.96d75e5d.js\",\"2bqSD\",\"pt-BR.10f91e79.js\",\"gZU54\",\"pt-BR.735a5974.js\",\"3fuR9\",\"pt-BR.b55187ea.js\",\"aGECO\",\"pt_PT.b38348c7.js\",\"aOdaf\",\"ro.9b8af727.js\",\"j6IGj\",\"ro.b5d74be6.js\",\"hlJc4\",\"ro.968019e9.js\",\"bSjyK\",\"ro.8940bbdc.js\",\"aEAsN\",\"ru.6b2fe232.js\",\"bJykp\",\"ru.2a448b30.js\",\"4Wdqb\",\"ru.0ee7758e.js\",\"fMrUo\",\"ru.f0bbf79a.js\",\"5WkxF\",\"sk.d2eeea9b.js\",\"l6YHr\",\"sv.0b6c9515.js\",\"dh2Er\",\"sv.e6031ecb.js\",\"k10Cs\",\"sv.86c76cc3.js\",\"9eNkX\",\"sv.12cce2b0.js\",\"l7PQP\",\"th.93fb5ab5.js\",\"77dzh\",\"tr.7eaab549.js\",\"eBLgB\",\"tr.a4d35ce1.js\",\"1n8w9\",\"tr.3eb3588d.js\",\"h0uBE\",\"tr.a1624066.js\",\"fLjHM\",\"uk.7a8159bb.js\",\"3YGga\",\"vi.a291c6ef.js\",\"afU9w\",\"zh_TW.946af287.js\",\"bV8sS\",\"zh-TW.90b55434.js\",\"l079e\",\"zh-TW.ccfc62fe.js\",\"j9OUx\",\"zh-TW.f38ae786.js\",\"7iCpI\",\"zh.f268ea44.js\",\"eLlpV\",\"zh-CN.914fb213.js\",\"f1B4n\",\"zh-CN.0b98a97a.js\",\"gDiIK\",\"zh-CN.268ccaa6.js\",\"2lsX7\",\"main.33e42dd9.js\",\"1S9KM\",\"lock-locked--lock-circle.8a4d7155.js\",\"3GB1F\",\"conversation-assistant-viz.2c0373a4.js\",\"slRZz\",\"charts.af746de2.js\",\"2WsUw\",\"charts.234d9e2a.js\",\"a4mwL\",\"charts.8af12b35.js\",\"kOn6A\",\"charts.2d57e9f1.js\",\"bEjND\",\"charts.f93019f9.js\",\"cjD72\",\"archive.9891846f.js\",\"2eoAj\",\"archive.runtime.ba71d6fc.js\",\"2eoAj\",\"archive.runtime.ba71d6fc.js\",\"iraZ1\",\"react-markdown.714fe5e5.js\",\"jfCh6\",\"rovo.b06223c6.png\",\"bHRnB\",\"deep-research-icon.837407f5.svg\",\"7rHnm\",\"rovo-chat-bubbles.54b3ac52.svg\",\"ixTAZ\",\"text-field.3fa52048.js\",\"bvkpZ\",\"text-area.732a8a35.js\",\"e3d45\",\"date-time-picker.16f5bb45.js\",\"hvGeE\",\"date-time-picker.65f81449.js\",\"d34hg\",\"gic-anywhere.82b4276e.js\",\"2272L\",\"modal.cd36f54c.js\",\"19D1M\",\"modal.runtime.97334f10.js\",\"19D1M\",\"modal.runtime.97334f10.js\",\"gvJDI\",\"generic-issue-type-icon.b13acfc5.svg\",\"i7J2B\",\"avatar-with-arrow-darkmode.d9464bf1.svg\",\"2FbWf\",\"avatar-with-arrow.71e68580.svg\",\"3Xxws\",\"avatar-with-lock-darkmode.39948dbb.svg\",\"85zTu\",\"avatar-with-lock.b0750eee.svg\",\"girkx\",\"pencilled-field-with-arrow-darkmode.9a09e770.svg\",\"dCfoG\",\"pencilled-field-with-arrow.6615a67d.svg\",\"dG1sE\",\"text-field-with-lock-darkmode.6b00710c.svg\",\"jQD4g\",\"text-field-with-lock.548927e7.svg\",\"hZ3Uy\",\"text-field-with-tick-darkmode.49503976.svg\",\"h1tvj\",\"text-field-with-tick.9650a889.svg\",\"jALB7\",\"database-icon.af3511fd.svg\",\"aLbrw\",\"live-docs-icon.5595b5be.svg\",\"fe7gr\",\"page-icon.4dd78b86.svg\",\"cknJE\",\"preview-card-database-header.8549ac7f.svg\",\"gMvyv\",\"preview-card-page-header.8639e9c6.svg\",\"6p1RF\",\"preview-card-whiteboard-header.a8b554de.svg\",\"fuzt0\",\"whiteboard-icon.552d11f4.svg\",\"i8OmD\",\"loom-script-in-confluence-chat-call-to-action-panel.de134b39.js\",\"iCR8j\",\"agent-debug-modal.a298e49f.js\",\"37ldp\",\"ErrorComponent.82a1a76b.js\",\"7PMju\",\"refractor.4bbd520a.js\",\"7f9Fz\",\"CommentEditor.e39e16c9.js\",\"bWQZc\",\"3p-product-configs.a166b58b.js\",\"397zr\",\"conversation-assistant-auto-suggest.d3846e96.js\",\"lXkAL\",\"InformationModal.88de8fc4.js\",\"2xz6W\",\"feedback-flag.66cb31f5.js\",\"lc53W\",\"local-frontend-components.5293d78d.js\",\"a4HB6\",\"conversation-assistant-agent.96591b30.js\",\"l3kSC\",\"retry.d3d082f7.js\",\"a4yJG\",\"folder-open.6a0f53ed.js\",\"cU3hB\",\"smart-creation-wrapper.3c63a760.js\",\"dBmpO\",\"smart-creation-wrapper.2d4bedcb.js\",\"lPsQk\",\"error-smart-create-icon.94df62fb.svg\",\"hSDlK\",\"Rovo-loadingV2.b5f1b3c5.gif\",\"hLrnF\",\"esm.21999d7b.js\",\"d2ioG\",\"esm.runtime.132213c1.js\",\"cyGuT\",\"feedback-collector.6f0f50b0.js\",\"3EXzu\",\"render.e43be1d0.js\",\"dTsOE\",\"modal.e37b1c5a.js\",\"lvjx6\",\"panel.fd8c434a.js\",\"bWVxZ\",\"panel.1ac21683.js\",\"2DakT\",\"panel.runtime.ae88f605.js\",\"5KksE\",\"RelatedLinksModal.c7d7680e.js\",\"i4cia\",\"component-lazy.80f6426e.js\",\"kDqHr\",\"file-icon.22bc916f.js\",\"4HZlX\",\"chart-bar-icon.df50cf8f.js\",\"7jSfd\",\"list-bullet-icon.cb0c6e79.js\",\"jYrum\",\"component-lazy.1ad4b091.js\",\"jzQa8\",\"component-lazy.2878700c.js\",\"gGCYy\",\"sha256SimpleHasher.481ff7cc.js\",\"54Aje\",\"sha256SimpleHasher.runtime.b1fc6456.js\",\"7RxKY\",\"component-lazy.2b36e279.js\",\"2jMZq\",\"component-lazy.runtime.52d688d4.js\",\"54Aje\",\"sha256SimpleHasher.runtime.b1fc6456.js\",\"2jMZq\",\"component-lazy.runtime.52d688d4.js\",\"hv4mn\",\"modal.fe109fa9.js\",\"5CdWD\",\"embedCard.baabd0c8.js\",\"aeEUI\",\"modal.2f2b8c26.js\",\"cmCrq\",\"modal.34d5af12.js\",\"3Krgg\",\"mention.c18d778e.js\",\"2KJHS\",\"esm.c998e094.js\",\"hyqsV\",\"esm.e99e8d08.js\",\"St9Nk\",\"AgentProfileCard.744ddda0.js\",\"c9Qqc\",\"auto-dev.232d76cf.js\",\"1TK6P\",\"auto-fix.257eceb2.js\",\"grvAy\",\"auto-review.0fe9b7f1.js\",\"23K0q\",\"backlog-buddy.d757d61a.js\",\"3kQkj\",\"comms-crafter.36507020.js\",\"6OXgE\",\"culture.33e027e3.js\",\"cbucA\",\"customer-insight.7dfcf35a.js\",\"bVhr1\",\"decision-director.35d226a4.js\",\"kE0QC\",\"feature-flag-avatar.f9d8e991.js\",\"eVFXf\",\"generic-avatar.cd98d7cb.js\",\"9FhBz\",\"hire-writer.7ebbca98.js\",\"6zB8z\",\"marketing-message-maestro.7404e3da.js\",\"eENGY\",\"my-user-manual.ac6d3669.js\",\"hmlb0\",\"okr-oracle.0602d51c.js\",\"2NGxc\",\"ops-agent.012e195b.js\",\"bPgcq\",\"pitch-perfector.e73b56ef.js\",\"31b1q\",\"product-requirement.2ba2b672.js\",\"8Lh9U\",\"release-notes.3c1911fc.js\",\"6ZzYJ\",\"research-scout.e2c817ef.js\",\"2zIbn\",\"rovo-dev.f6f9366f.js\",\"410SS\",\"social-media-scribe.e5fe68a5.js\",\"z3s9q\",\"team-connection.5f505a11.js\",\"9gqcE\",\"workflow-builder.07423129.js\",\"jdLWZ\",\"AgentProfileCard.19ceb643.js\",\"h6IMw\",\"AgentProfileCard.171053fe.js\",\"cR6a5\",\"FullPageEditorComponent.a8495f68.js\",\"jDSPZ\",\"FullPageEditorComponent.runtime.b264ebf9.js\",\"5fl7e\",\"FullPageEditorComponent.341d1418.js\",\"aRyGW\",\"FullPageEditorComponent.runtime.c488ed87.js\",\"kqWUF\",\"CommentEditor.3454afb8.js\",\"j7M16\",\"CommentEditor.a75b8f94.js\",\"dt2jU\",\"team-preview-panel.b06eff76.js\",\"1DYgg\",\"team-preview-panel.8f31a7ac.js\",\"6rXKh\",\"FullPageEditorComponent.7d46a6c1.js\",\"2fk6g\",\"16.39b6cb2e.js\",\"72780\",\"24.43557862.js\",\"eTBsW\",\"16.6f5a520f.js\",\"lxiFd\",\"16.bfa31662.js\",\"6HBYC\",\"16.10256d2c.js\",\"bYxCZ\",\"16.733e7fd3.js\",\"hszIA\",\"24.9fce27aa.js\",\"eVYW1\",\"16.ae0fb140.js\",\"020xd\",\"16.54d36bc8.js\",\"6vhrJ\",\"24.25e29644.js\",\"4jPsO\",\"24.ea1906ea.js\",\"ls0Um\",\"16.055b6b2a.js\",\"jDjSj\",\"16.a1d2270e.js\",\"8059b\",\"16.77f9d828.js\",\"3wmvj\",\"16.6efd8621.js\",\"hPalR\",\"16.782a40c1.js\",\"ijPJo\",\"spreadsheet.8bd9df3a.js\",\"euJgP\",\"preview-bg.12045916.svg\",\"49cor\",\"agent-section.39718adf.js\",\"4T3hD\",\"conversation-assistant-agent.b3609335.js\",\"6faJ6\",\"lock-locked--lock.c940389d.js\",\"3kUQf\",\"eye-open-strikethrough.f218ba66.js\",\"kvwtq\",\"star-starred--star-filled.ff6efd9b.js\",\"lUlCu\",\"star-starred.9b99dc04.js\",\"aKNGF\",\"star-unstarred--star.3de48f64.js\",\"3qsjq\",\"star-unstarred.3e52de8c.js\",\"3RGYS\",\"briefcase--suitcase.21804e5c.js\",\"4Jbf1\",\"sprint.69e64865.js\",\"8Qv5g\",\"transition.dc10ff19.js\",\"3fdRd\",\"recommended-agents-preloader.6fd36271.js\",\"2tSa5\",\"main.4d97c831.js\",\"gSlDz\",\"main.eb538926.js\",\"k08Ot\",\"main.f1689dc5.js\",\"6hCrU\",\"CommentEditor.711b79c8.js\",\"8sIhy\",\"main.70366a86.js\",\"6fU2k\",\"drag-handle.268cbea8.js\",\"gYTHw\",\"mention.8b8c3c23.js\",\"8c4Ih\",\"mention.runtime.b24da38e.js\",\"fkD5j\",\"main.d04efe86.js\",\"4AfJ2\",\"FullPageEditorComponent.5310965e.js\",\"8c4Ih\",\"mention.runtime.b24da38e.js\",\"aRyGW\",\"FullPageEditorComponent.runtime.c488ed87.js\",\"d2ioG\",\"esm.runtime.132213c1.js\",\"2DakT\",\"panel.runtime.ae88f605.js\",\"jDSPZ\",\"FullPageEditorComponent.runtime.b264ebf9.js\",\"gM13h\",\"navBarButton.9fa984cc.js\",\"gryT8\",\"ShareButton.27137d57.js\",\"hwiu3\",\"NavigationLockout.b1900bd2.js\",\"6rpul\",\"ArchivedPageBannerV2.a249fb7f.js\",\"dxDVc\",\"UnarchivePagesLoader.7d93e119.js\",\"ktyyJ\",\"TrialFlags.e9ebf94b.js\",\"fO3hx\",\"esm.ced70e25.js\",\"htECn\",\"TrialFlags.c7a8a016.js\",\"4zlcK\",\"avoid-deactivation-data-modal.0db79937.js\",\"bpZy3\",\"user-brand-dark.2dd77a4f.svg\",\"4B6ye\",\"user-brand-light.f1d0cd78.svg\",\"g2AXX\",\"user-gray-dark.8d7964d6.svg\",\"30svi\",\"user-gray-light.4df874b4.svg\",\"jfplD\",\"TrialFlags.bf506d14.js\",\"4yUSc\",\"PremiumLozenge.ad445124.js\",\"ePA5l\",\"Lozenge.ee1dd8b5.js\",\"cPGpO\",\"premiumLozenge.aa9b0435.svg\",\"fqBFU\",\"ReverseTrialLozenge.5395ba19.js\",\"1HAEl\",\"ReverseTrialListItem.4115cf7f.js\",\"8qpSy\",\"ErrorSectionMessage.7b429a47.js\",\"i5EJc\",\"ErrorComponent.bd23100a.js\",\"2wJza\",\"ErrorGraphic.784b3ce3.svg\",\"97s9d\",\"schemaLink.7043eff2.js\",\"29Aqg\",\"RendererContentStateWithSpotlight.4a2ccb00.js\",\"djzzD\",\"PageLabelsAutomationDiscovery.a130d6a0.js\",\"f7WA2\",\"SlackDiscoveryDialog.d924b139.js\",\"eRzO9\",\"BulkChangePageOwnerDialog.1241b15a.js\",\"1rMtp\",\"PagePublishAutomationDiscoveryDialog.a5633071.js\",\"jdEwy\",\"JiraLinkAutomationDiscoveryDialog.fa024408.js\",\"696ho\",\"WhiteBoardPublishDiscoveryDialog.134de452.js\",\"1NKZf\",\"AutomationDiscoveryHoverPageTitleMessage.903595f3.js\",\"6sAbi\",\"ArchivePageAutomationDiscovery.c23a0f61.js\",\"11AeH\",\"AutomationDiscoveryHeader.6db01409.svg\",\"7WcBh\",\"UnarchivePagesLoader.176c92a7.js\",\"dMZLS\",\"UnarchivePagesLoader.c5ca1098.js\",\"eozMQ\",\"UnarchivePagesLoader.6f36bb6b.js\",\"hBh8x\",\"UnarchivePagesLoader.03a0bd8c.js\",\"1u9sS\",\"UnarchivePagesLoader.87fc072f.js\",\"in6Mc\",\"NoChildrenBullet.00ba4557.js\",\"iQ0Jm\",\"UnarchivePagesLoader.9ffcf1a8.js\",\"g5te7\",\"ArchivedPageBannerV2.c683b30f.js\",\"3uux1\",\"ArchivePagesLoader.fe1e4a23.js\",\"cPaXL\",\"ArchiveUpsellDialog.54b48fc8.js\",\"anGwD\",\"BulkArchivePagesLoader.d5020668.js\",\"f0OaY\",\"ArchiveRemoteProcessContainer.e349b93f.js\",\"hVNnP\",\"UpdateArchivedPageNoteDialog.fb5b5448.js\",\"b6JBs\",\"CompanyHubBreadcrumbs.4887b713.js\",\"lpcEN\",\"ChangeHubNameDialog.b0895c9e.js\",\"70fET\",\"hub-hero-image.d6790ccb.png\",\"1GyAj\",\"BreadcrumbsDropdownContent.7a2f3c1f.js\",\"36rXN\",\"MovePageDialog.b9021443.js\",\"eMbU0\",\"SpaceSelector.b9d4be1e.js\",\"h4Nf7\",\"ExternalUserLozenge.6c39b83e.js\",\"i5Fj1\",\"data-classification.39291336.js\",\"jnk96\",\"DataClassification.323fee9d.js\",\"gEi5K\",\"NotFound.c04604fe.js\",\"QfEJc\",\"NotFoundIcon.ab9d1086.svg\",\"iMSgb\",\"log-in.9b553c7d.js\",\"3b99S\",\"EditorContentClassificationTag.1e20ae5a.js\",\"1zPhe\",\"EditorDataClassification.1f965afd.js\",\"avzJW\",\"EditorDataClassificationComponent.f039250a.js\",\"4Oj5y\",\"ContentTypeClassification.cf9c57b0.js\",\"iJsKa\",\"ClassificationReadViewPopup.80b9b70b.js\",\"cEDfx\",\"DataClassificationHoverButton.670ede3e.js\",\"9wTW2\",\"EditorClassificationTagWrapper.5e019b1c.js\",\"3eGPE\",\"SpaceSelector.8bc07e26.js\",\"5odbj\",\"ClassificationTagButtonError.e4bb343e.js\",\"58UdM\",\"ClassificationEditViewPopup.f9f6fe61.js\",\"4Qstt\",\"ClassificationEditModal.5b91fce4.js\",\"ltXeo\",\"PageTree.3f01794f.js\",\"4JUnA\",\"BulkDeletePagesAction.21b74638.js\",\"kgbtU\",\"BulkDeletePagesAction.8d8f5656.js\",\"gODOu\",\"RtPaidFeatureEducationSpotlightTarget.631a6d33.js\",\"dkv9z\",\"PageTreeAfterIcon.1248567f.js\",\"9F7vX\",\"CreateContentPopover.726932c6.js\",\"dnVDi\",\"top-nav-items.7ec4468c.js\",\"kPjzV\",\"OnboardingNudgeTooltip.1d606217.js\",\"8VRAf\",\"CommentEditor.e2bc3278.js\",\"daoWf\",\"LoomCrossSellPopupCardImage.6e60c328.png\",\"jBwbI\",\"LoomMigrationModalManager.53ffea51.js\",\"3jZMP\",\"loomMigrationModalImage.fa8ef03b.svg\",\"1wrZ9\",\"vector.07efb279.svg\",\"014Eq\",\"pageHeaderSpotlightImage.b1e98e59.png\",\"ipnbL\",\"createSpotlightImage.f64dc988.png\",\"c0kqt\",\"TreeBottomCreateButton.4673f5de.js\",\"4Dabn\",\"ContextualCreateContentPopoverMenu.cb7c372b.js\",\"jcby2\",\"FullPageEditorComponent.d2cbaec1.js\",\"5i0u2\",\"FullPageEditorComponent.runtime.1f9315bd.js\",\"6Ju7D\",\"ContextualCreateContentPopoverMenu.8b3889f4.js\",\"3OZOS\",\"database.2a5a6e18.gif\",\"jDLf6\",\"folder_space.4db7be29.gif\",\"nLzCZ\",\"live_page.21be0d2b.gif\",\"4kpzK\",\"loom.4e5a8d5b.gif\",\"gfw8L\",\"page.cc74cd19.gif\",\"8p9Qn\",\"smart_link.98982781.gif\",\"4SZ7J\",\"whiteboards.caa514dd.gif\",\"iw0Pi\",\"ai.853086d4.gif\",\"bxW4e\",\"blueBar.ae629b00.svg\",\"6LpHZ\",\"greenBar.869cd775.svg\",\"ePdd1\",\"orangeBar.96a843e1.svg\",\"53OS2\",\"purpleBar.40dceaa5.svg\",\"h4qu8\",\"LiveDocsIntroGif.d2fc0787.gif\",\"j7hKO\",\"LiveDocIntroGADark.45e6357d.svg\",\"7yu5V\",\"LiveDocIntroGALight.8a32f41a.svg\",\"5TJ4V\",\"WhiteboardExperimentSpotlightImage.49c94c1b.svg\",\"iUB8p\",\"WhiteboardsPaywall.cf2c63af.svg\",\"1TlSS\",\"WhiteboardsPaywallDark.0948bce6.svg\",\"l53uS\",\"SpotlightGif.cc562f5c.gif\",\"9lsAF\",\"ContextualCreateContentPopoverMenu.a7caf9c9.js\",\"eLGEE\",\"ContextualCreateContentPopoverMenu.1de40422.js\",\"5pF3s\",\"ContextualCreateContentPopoverMenu.91a05171.js\",\"dVM1q\",\"EditorPageCoverPictureEntry.d158e4fb.js\",\"gGhXk\",\"EditorPageCoverPicture.95c8e3fa.js\",\"6aruy\",\"media-client-react.f156b245.js\",\"h4k4y\",\"media.fc885320.js\",\"b8BDn\",\"js.a0af0607.js\",\"dLFEp\",\"png-chunks-extract.4b734ea9.js\",\"hqblC\",\"browser.4fe71ae1.js\",\"4lnLb\",\"media-viewer-error-boundary.6b5af2a8.js\",\"huUvS\",\"16.f4d29d37.js\",\"1oiJ6\",\"16.9b0cfada.js\",\"eDqo1\",\"16.c9c1057f.js\",\"f35QR\",\"16.10d23cc6.js\",\"bTmOC\",\"cards-extension.0f5bab77.js\",\"98UJI\",\"cards-extension.79326ee2.js\",\"4hycL\",\"NoResults.9d75157a.svg\",\"9O0VQ\",\"ReadTimePopup.59f2b497.js\",\"kYzDf\",\"ReadTimePopup.runtime.eddeb513.js\",\"kYzDf\",\"ReadTimePopup.runtime.eddeb513.js\",\"1CVqv\",\"PreviewPageCoverPicture.addfd51d.js\",\"4Bg7q\",\"RendererPageCoverPicture.b1e243a9.js\",\"5i0u2\",\"FullPageEditorComponent.runtime.1f9315bd.js\",\"3rFQl\",\"CreateContentPopover.0eb18a41.js\",\"dwffN\",\"GlobalCreateContentPopoverMenu.1d2b76a2.js\",\"kiDFE\",\"CreateSpaceMenuItem.241f1f22.js\",\"lWi9V\",\"CreateSpaceMenuItemNav3.e72e6f29.js\",\"3tVyh\",\"CreateSpacePlusButton.08bd8108.js\",\"kr1hG\",\"cs.ca5c40fc.js\",\"ins06\",\"da.9cf254eb.js\",\"9vQGB\",\"de.3b040eaf.js\",\"kaLOH\",\"en_GB.db20b3f8.js\",\"bF0Yj\",\"en_ZZ.77796f1c.js\",\"iTdzs\",\"es.ebdfe882.js\",\"5Tak1\",\"fi.6b565d7e.js\",\"7NfA4\",\"fr.275271ad.js\",\"5Psde\",\"hu.68ff1cb2.js\",\"k90B6\",\"it.159856ad.js\",\"98bRK\",\"ja.eec193c8.js\",\"gePdq\",\"ko.47eec8aa.js\",\"6eObS\",\"nb.275a0df0.js\",\"cvIfq\",\"nl.884b6dcb.js\",\"aDvHP\",\"pl.a2f2f2c1.js\",\"fih2D\",\"pt_BR.f32e089a.js\",\"2IvvO\",\"ru.912ce6be.js\",\"dQMD4\",\"sv.d343992e.js\",\"epSPI\",\"th.d5e5e6a1.js\",\"e2RXi\",\"tr.757e54da.js\",\"iNX42\",\"uk.ac732961.js\",\"asamZ\",\"vi.0a907a06.js\",\"8X3OG\",\"zh_TW.1bbe1c9a.js\",\"3pTtv\",\"zh.6c039625.js\",\"eZu0L\",\"goal.82a588bb.js\",\"6Yu8N\",\"ShareButton.251845bf.js\",\"lAgcW\",\"ProfileCard.c7b072f8.js\",\"1Pok1\",\"key-result.3e2e8c95.js\",\"jtcRz\",\"objective.9e034c80.js\",\"kji1k\",\"GoalLinkerGoal.ae20781d.js\",\"cdKaZ\",\"LinkedGoalsEmptyState.e776fe47.svg\",\"g55vn\",\"team.4151e6db.js\",\"35VU5\",\"cs.d801dcbc.js\",\"6W6gh\",\"da.bac7ddcf.js\",\"bfTAm\",\"de.c95398fc.js\",\"fP9up\",\"en_GB.47d12276.js\",\"hc0i6\",\"en.747f8213.js\",\"15E48\",\"en_ZZ.299e4f49.js\",\"jLWG0\",\"es.7e41636e.js\",\"9J49E\",\"fi.89090e5d.js\",\"br9SP\",\"fr.2a048ea9.js\",\"5h4sF\",\"hu.c2dc4635.js\",\"1MV5Z\",\"it.05b27b71.js\",\"iV5Fv\",\"ja.7b259d22.js\",\"7R5mJ\",\"ko.203f86ca.js\",\"5XMUp\",\"nb.e44f5efd.js\",\"jaDFz\",\"nl.405ee529.js\",\"LOg5S\",\"pl.23c5179b.js\",\"lnJdQ\",\"pt_BR.805e95d7.js\",\"hqsLl\",\"ru.c980f637.js\",\"j0btO\",\"sv.9635f53d.js\",\"2YEqr\",\"tr.ddf2ab95.js\",\"7zFV7\",\"th.3ecc11fa.js\",\"fZ22O\",\"uk.04a59e12.js\",\"4tleS\",\"vi.cca22a6d.js\",\"bE6tX\",\"zh_TW.af40ed8f.js\",\"esYD7\",\"zh.8eeac7b4.js\",\"lxJNk\",\"CoreInvites.b4b5e21d.js\",\"h05Zl\",\"ufo.1597da7c.js\",\"7aFUb\",\"ProjectPanel.135f3b86.js\",\"kC80R\",\"esm.4a4f8fc8.js\",\"6AiL8\",\"esm.0322cd99.js\",\"4lSDd\",\"esm.runtime.54d233a9.js\",\"4lSDd\",\"esm.runtime.54d233a9.js\",\"jvHRs\",\"team-preview-panel.04032fb3.js\",\"9MRac\",\"team-preview-panel.9c35f9cf.js\",\"48eS0\",\"cs.ef82ab14.js\",\"lak6L\",\"da.5fea4caa.js\",\"inCHL\",\"de.dff136b6.js\",\"lLx4a\",\"en.9ea3609c.js\",\"auTAr\",\"en_GB.d3e96a64.js\",\"9pxVf\",\"en_ZZ.578d7a34.js\",\"4cEzx\",\"es.cbbb3b96.js\",\"iUIL3\",\"et.8f07e723.js\",\"lADZV\",\"fi.01736213.js\",\"1QHKh\",\"fr.978376aa.js\",\"2Tjcq\",\"hu.70b5c043.js\",\"4WVVc\",\"is.aa3b7b54.js\",\"1QNch\",\"it.a8e146a3.js\",\"jQCyA\",\"ja.6b224cd4.js\",\"aQwae\",\"ko.356602be.js\",\"cS1j1\",\"nb.771d8523.js\",\"48pzM\",\"nl.ae53f351.js\",\"c4a0F\",\"pl.81966d06.js\",\"cBmO4\",\"pt_PT.fb87e247.js\",\"9e3Ob\",\"pt_BR.3eae19cd.js\",\"7Hoje\",\"ro.6553ad3e.js\",\"4dj0m\",\"ru.adb683fa.js\",\"j5HYK\",\"sk.89deb301.js\",\"1VsiM\",\"sv.f045be3d.js\",\"8CqFM\",\"tr.ca025062.js\",\"5bAmA\",\"th.1e620c1a.js\",\"i0Evx\",\"uk.c3200142.js\",\"j8OKz\",\"vi.8b528b05.js\",\"2s1Lz\",\"zh.066f46c2.js\",\"iI3rq\",\"zh_TW.23a4ca11.js\",\"hLVzM\",\"suggested-edit.9edafd06.js\",\"lRtGG\",\"dashboard.839aaa25.js\",\"adH3p\",\"roadmap.beb86071.js\",\"k97iL\",\"focus-area.6dcaf5d4.js\",\"5BMnr\",\"calendar-plus.435c4b76.js\",\"4byV5\",\"is-supported.f06bc1d2.js\",\"lwKXH\",\"is-supported.7a02a63d.js\",\"btYwu\",\"esm.df24f86b.js\",\"wIOhQ\",\"esm.f6c7f163.js\",\"9LQGG\",\"close.f1edfb26.js\",\"lLK0D\",\"video-pause-overlay.bf3f58b5.js\",\"fisfU\",\"video-play-overlay.0278a0bb.js\",\"4drdS\",\"paint-palette.52c44fbd.js\",\"jle6Z\",\"premium.3f265b33.js\",\"xvDzM\",\"success.1bcc5fc4.js\",\"a3Uq6\",\"esm.a58beee4.js\",\"clpSH\",\"PageTreeQuickActions.08f52733.js\",\"13PnU\",\"QuickActionsContent.a15517c8.js\",\"bunf9\",\"Controller.a4e12494.js\",\"4opMD\",\"ShareRestrictAndCopyCoordinator.6a875343.js\",\"9PeA0\",\"GrantAccessDialog.43e35fed.js\",\"8MBNg\",\"EndOfPageRecommendation.cd277a68.js\",\"cpDT3\",\"EndOfPageRecommendation.e58d4ea0.js\",\"c4Kdp\",\"GeneralAccessLevelSelector.436b4229.js\",\"k9ktU\",\"OnboardingNudgeTooltip.5da4ead7.js\",\"8Kyi2\",\"OnboardingCTANudge.b9efe839.js\",\"k0hwN\",\"ShareToSlack.37a780a0.js\",\"lVO4z\",\"cs.66d17b1d.js\",\"2FVbf\",\"da.45f5bf76.js\",\"ljo6M\",\"de.87ff8d2a.js\",\"8d6ia\",\"es.44f7b6ae.js\",\"jh8UJ\",\"fi.bd46bce1.js\",\"bYwCr\",\"fr.854524fc.js\",\"11NiT\",\"hu.21eb6dc5.js\",\"le8VA\",\"it.111da4a0.js\",\"1beJ2\",\"ja.25f13916.js\",\"1tXCh\",\"ko.c7b3c730.js\",\"jzP8g\",\"nb.6ab8a8d0.js\",\"dJY66\",\"nl.b11fd7f9.js\",\"4foYW\",\"pl.200ddf23.js\",\"j0yc3\",\"pt_BR.3fad7d31.js\",\"RfEmw\",\"ru.64b44490.js\",\"5DOlG\",\"sv.812498a9.js\",\"6rD7n\",\"tr.6280d059.js\",\"1e62a\",\"th.646e04f8.js\",\"eLsCU\",\"uk.87a103d8.js\",\"g9qHs\",\"vi.352e605d.js\",\"2ri5s\",\"zh_TW.40e2425f.js\",\"3k60n\",\"zh.af15c051.js\",\"hxIYN\",\"integration-primer.cead19d9.svg\",\"5oKDR\",\"disabled-alert.0ba0a4e5.svg\",\"8LPnw\",\"lock-locked--lock-filled.572a51f5.js\",\"a0ogJ\",\"link--link-filled.7b54b8c4.js\",\"fEVHM\",\"CoreInvites.935b8278.js\",\"7oczk\",\"cs.4da6ec84.js\",\"e2gl6\",\"da.92e1a20b.js\",\"9oo3s\",\"de.949a6b27.js\",\"1ZyUV\",\"es.c52c200d.js\",\"6tijD\",\"et.a748dc81.js\",\"6fkVy\",\"fi.14d12f06.js\",\"5nw5x\",\"fr.99ae2fd0.js\",\"jK12s\",\"hu.c6563fe5.js\",\"6lWvL\",\"is.e7fee0c5.js\",\"kk9To\",\"it.165dc383.js\",\"lyt83\",\"ja.c888829c.js\",\"2uvfp\",\"ko.caee176c.js\",\"4Wx8B\",\"nb.b215ce05.js\",\"huTg5\",\"nl.991f3345.js\",\"fPfEd\",\"pl.fdd8fa15.js\",\"fTYhL\",\"pt_BR.9a48d763.js\",\"dVHhf\",\"pt_PT.137566ba.js\",\"2SsCI\",\"ro.a2a72a07.js\",\"kVi5E\",\"ru.73740831.js\",\"6HoYh\",\"sk.63554299.js\",\"kOAvl\",\"sv.bebc1fbd.js\",\"5ErHy\",\"tr.36b807a9.js\",\"jJzpI\",\"th.64051e8c.js\",\"2PvRH\",\"uk.d1a904b6.js\",\"eUGjU\",\"vi.d80ec259.js\",\"drbCf\",\"zh_TW.d982069e.js\",\"5dk6T\",\"zh.dda96faa.js\",\"7pAFt\",\"WarningIllustration.6f86942e.js\",\"2CfIU\",\"WarningIllustration.ec26752f.png\",\"85liN\",\"InspectPermissionsDialog.1638f3b1.js\",\"QcHuP\",\"InspectPermissionsDialog.5d25c2dd.js\",\"aX0L0\",\"InspectPermissionsDialog.b3d41ccf.js\",\"dMOc8\",\"projection-screen.1d8acbb5.js\",\"iO9O1\",\"personal_space.c63f5733.png\",\"13QWg\",\"in-trial-feature-gates-banner.d1b29d37.js\",\"dGk3x\",\"GlobalFeedbackCollector.f084e629.js\",\"8Yk54\",\"DarkEmptyState.b237e8cb.png\",\"dEQI1\",\"LightEmptyState.1b72e55d.png\",\"2i7Iv\",\"DarkError.d13c9c5b.png\",\"17ygR\",\"LightError.5b516166.png\",\"1sXQt\",\"FavouriteButton.2bff420f.js\",\"4Xnj4\",\"NativeCollabComponent.b09813d1.js\",\"KS1sL\",\"ContentTypesHeader.c6c42ed5.js\",\"3bo82\",\"ShareButton.8dec61cd.js\",\"1TOYq\",\"CoreInvites.8d8ff53d.js\",\"8D2l8\",\"ShareButton.b02872db.js\",\"jOlrD\",\"LazyShareForm.fd1311e3.js\",\"dZF6I\",\"CoreInvites.58b1fe8d.js\",\"bj1Oi\",\"LazyShareFormNext.b0c94139.js\",\"8M2wy\",\"LazyShareFormNext.d1942c5a.js\",\"gwFU3\",\"share.d3d45e7a.js\",\"ew1CD\",\"ShareButtonLite.ce35b286.js\",\"9QyoN\",\"PageQuickActionAutomationMenu.8f35c829.js\",\"96s6s\",\"RendererContentStateWithSpotlight.a5991bc1.js\",\"kCTMZ\",\"PageQuickActionAutomationMenu.433c6c0b.js\",\"aOpoD\",\"empty-automation-list.9c7d0496.png\",\"awXdT\",\"error.b6351f9e.svg\",\"9YGIy\",\"DeleteNestedPagesAction.7b12f7df.js\",\"iomzR\",\"DeletePageDialog.f86c8d93.js\",\"p4ay7\",\"CopyPageTreeContainer.77f6f23f.js\",\"l5XQ1\",\"ViewSpaceExternalCollaboratorsDialog.74246b00.js\",\"hA2SB\",\"GroupAndUserItem.f80230f0.js\",\"iHlO3\",\"empty-filter.16dda5ac.svg\",\"5uN9h\",\"arrow-up-right.b9da73d9.js\",\"cv53Q\",\"GroupAndUserItem.b69bc430.js\",\"j4POW\",\"GroupAndUserItem.5900b819.js\",\"lookM\",\"user-header-for-space-with-guests-Light.1b10bf7d.svg\",\"2GHvs\",\"user-header-for-space-with-guests-Dark.3d8c1f10.svg\",\"5ppK3\",\"MovePageDialog.1dd0edaa.js\",\"aiU5r\",\"CopyPageDialogContainer.5b4f97cb.js\",\"aoUod\",\"MoveBlogModal.25bd4195.js\",\"hOsjc\",\"ResolvedInlineCommentsDialog.4c3f847d.js\",\"6bJ81\",\"CommentEditor.80341cb2.js\",\"dzGZb\",\"CommentEditor.runtime.32f283a0.js\",\"dzGZb\",\"CommentEditor.runtime.32f283a0.js\",\"km34l\",\"ResolvedInlineCommentsQueryRenderer.db9e293a.js\",\"aS96v\",\"ResolvedInlineCommentsCounter.a3baab98.js\",\"hbc6v\",\"TitleAreaContentComponents.67997d62.js\",\"7GtpA\",\"EditorAppearanceButtonNext.d2794743.js\",\"eAs6a\",\"ObjectSidebarControl.985ad36d.js\",\"65d3q\",\"SpaceAdminConfig.b4ea4131.js\",\"9lDKI\",\"SatisfactionSurveyModal.9e0f9947.js\",\"f8xBv\",\"SatisfactionSurveyComponent.6bbfde3e.js\",\"4csuu\",\"terrible.43df9387.svg\",\"ezTnP\",\"bad.1f02aedc.svg\",\"lKYkZ\",\"okay.fd894a28.svg\",\"eOIaN\",\"great.e17ca230.svg\",\"c1rvV\",\"amazing.0fceeb3a.svg\",\"ljCe8\",\"EditorContentState.515f453a.js\",\"9DDT5\",\"EditorContentStateComponent.ee7547e9.js\",\"f3bIn\",\"GenericError.42a632b0.svg\",\"azlpK\",\"RendererContentStateWithSpotlight.e12901cf.js\",\"50o6L\",\"PageHistoryContentState.ebca4077.js\",\"9opeZ\",\"RendererContentState.e7bb40b8.js\",\"5zDuS\",\"NativeCollabComponent.34d9dab3.js\",\"9AJEu\",\"TitleAreaContentComponents.e9339a4c.js\",\"dUTj8\",\"SmartCreateTitleAreaContentComponents.610f728b.js\",\"89b92\",\"PublishButtonWithMoreOptions.a351ad40.js\",\"inQqk\",\"RestrictionsDialog.e060662f.js\",\"9NxYX\",\"no-restriction-illustration-Light.a376c323.svg\",\"lpZU0\",\"no-restriction-illustration-Dark.8da66227.svg\",\"kgrX3\",\"no-restriction-illustration-pencil-Light.bcc52320.svg\",\"bRk6k\",\"no-restriction-illustration-pencil-Dark.5e6368e9.svg\",\"1DRtS\",\"no-restrictions-illustration-external-share-Light.85b8ab71.svg\",\"hhpRR\",\"no-restrictions-illustration-external-share-Dark.dff9aa3b.svg\",\"69XGw\",\"InspectPermissionsEntryPoint.025ebe43.js\",\"a8Jk0\",\"RestrictionsDialog.1a9bdb38.js\",\"24IdC\",\"Publish-Modal-Background-Image-Light.4e795a9a.svg\",\"dXonJ\",\"Publish-Modal-Background-Image-Dark.cd843bfb.svg\",\"gZ0i8\",\"PublishHubDialog.355eb93f.js\",\"57vSc\",\"PublishButtonWithMoreOptions.ceaaff9d.js\",\"anQQJ\",\"PublishModal.33b4dc26.js\",\"iQam7\",\"page.6c3ca97c.svg\",\"jIvk7\",\"whiteboard.d5787185.svg\",\"cuVen\",\"PublishButtonWithMoreOptions.6ee1f6dd.js\",\"fCqMy\",\"DiscardModal.9c2b7e1c.js\",\"a6uKK\",\"CancelSchedulePublishModal.4204cce1.js\",\"iY5MP\",\"EllipsisDropdown.93af09d4.js\",\"1fnbu\",\"EditLabelDialogComponent.dd410cc5.js\",\"jigcs\",\"LabelsSelect.33a10a2e.js\",\"718G0\",\"LabelsSelectErrors.1cbdaf7d.js\",\"4LmEY\",\"ViewPageLabels.28d9baf4.js\",\"23MlT\",\"RevertEditorDialog.c6bb2985.js\",\"RU02s\",\"ConvertToLivePageDialog.2054858d.js\",\"lJJQ8\",\"ViewChangesDialog.1b98ba91.js\",\"8OiWl\",\"ChangesDiff.194d7859.js\",\"2Mq3f\",\"megaphone.8faf2592.js\",\"hWs86\",\"ContentTools.8bdd974b.js\",\"dXoLf\",\"LinkToThisPageDialog.fa4c72d4.js\",\"momKe\",\"ExportShareAsPublicLink.6ea30173.js\",\"hRE4a\",\"ContentToolsItemForCopy.124a4c2a.js\",\"lUL2G\",\"FullPageEditorComponent.972c7774.js\",\"l9qI6\",\"FullPageEditorComponent.runtime.8f144d68.js\",\"iQDXb\",\"TableOfContents.50de2931.js\",\"iEvs6\",\"json-schema-validation.27474bc3.js\",\"kbLtt\",\"ReadTimePopup.1205aff9.js\",\"g9CVe\",\"mention.acd49770.js\",\"9L8th\",\"PageContentRendererFabric.130633fd.js\",\"aZinD\",\"vendors.3023fd3a.js\",\"jsjHl\",\"labels-footer.f9bfba8b.js\",\"kyfJT\",\"ForgeContentTools.aa56e2cf.js\",\"lnKog\",\"main.18094fd7.js\",\"bGzhS\",\"ByLineForgeApp.7194b536.js\",\"bf0yj\",\"modal-dialog.4ea336eb.js\",\"eMbal\",\"loading-button.90d63bac.js\",\"cjJTJ\",\"section-message.547b3afe.js\",\"jeyta\",\"no-results.603cf20f.svg\",\"5jaz2\",\"FullPageEditorComponent.449a0b6a.js\",\"6Dq0W\",\"FullPageEditorComponent.runtime.6cb9e7b0.js\",\"eaxi8\",\"ByLineForgeApp.b3bb35ad.js\",\"6Dq0W\",\"FullPageEditorComponent.runtime.6cb9e7b0.js\",\"bdzih\",\"ContentActionForgeApp.6e56e5bc.js\",\"cwpVK\",\"ContextMenuForgeApp.ab02303b.js\",\"68RC4\",\"FullPageForgeApp.edf1dcbc.js\",\"87cDu\",\"GlobalPageForgeApp.69a7b7cd.js\",\"iXr0W\",\"GlobalSettingsForgeApp.d0717d8f.js\",\"ccJug\",\"HomepageFeedForgeApp.4426455a.js\",\"irYLY\",\"SpaceSettingsForgeApp.b1b43e7a.js\",\"ldtPf\",\"SpacePageForgeApp.a90c2479.js\",\"6wcNV\",\"CustomContentForgeApp.af057f1d.js\",\"i9jMB\",\"BackgroundScriptForgeApp.17681968.js\",\"aFNXd\",\"PageBannerForgeApp.19433047.js\",\"bzc8Q\",\"ContentToolsItem.b682a660.js\",\"dRao7\",\"QuickActionsContent.68cab370.js\",\"fno6o\",\"RestrictionsDialogMountPoint.009c1fa5.js\",\"2VACG\",\"RestrictionsUpsellDialog.450ca073.js\",\"1zoBu\",\"ChangeEditionInlineDialog.0188d8eb.js\",\"4mWJk\",\"GrantAccessFlag.15e6ba37.js\",\"bfhXH\",\"RestrictionsButton.bf3ff484.js\",\"jdHbV\",\"LivePagesEllipsisDropdown.3018eaa5.js\",\"2nHxT\",\"QRCodeComponent.a55c289a.js\",\"289Xl\",\"customCursor.8a87402c.svg\",\"9IaUU\",\"Navigation.149687c6.js\",\"62AD8\",\"SettingsMenu.67a9a14b.js\",\"cfype\",\"ContentTools.6146d7ab.js\",\"fJjZJ\",\"PublishPageAsBlogDialog.7e3247ba.js\",\"4TY0p\",\"ContentToolsItemWithRoutesContext.73335a8c.js\",\"l9qI6\",\"FullPageEditorComponent.runtime.8f144d68.js\",\"34R0T\",\"AgentPresence.a954dbd6.js\",\"b8HYR\",\"ObjectSidebarPanelWrapper.6ac48f3f.js\",\"3YiKe\",\"ContentHeaderPresence.33930378.js\",\"5iVCs\",\"cs.6a4c25c7.js\",\"k7RZQ\",\"da.9877c37f.js\",\"9CFJc\",\"de.bb97d0fd.js\",\"3fPuK\",\"en_GB.9561a37b.js\",\"dUyEb\",\"en_ZZ.c7ec2c16.js\",\"PAD2J\",\"es.8b476d00.js\",\"GNuQo\",\"fi.625ea11d.js\",\"fvsAU\",\"fr.3c57c9b9.js\",\"h7dGJ\",\"hu.a577b1ea.js\",\"kg6sH\",\"it.bd75db28.js\",\"fqF5W\",\"ja.edd3a363.js\",\"1WNp5\",\"ko.b85ae1d4.js\",\"iHPxa\",\"nb.20c3bd75.js\",\"Qf3VH\",\"nl.573e6cdf.js\",\"79OEV\",\"pl.98acd127.js\",\"27dMt\",\"pt_BR.405f85d7.js\",\"bkVVv\",\"ru.c004cf49.js\",\"MLhYA\",\"sv.aaf78479.js\",\"ap7kW\",\"th.a4a6fd4b.js\",\"45YAR\",\"tr.b2cb22e6.js\",\"kqhVG\",\"uk.47e01bb2.js\",\"1susf\",\"vi.1184af6c.js\",\"dl3k2\",\"zh_TW.6e51a40f.js\",\"aquXY\",\"zh.f784abff.js\",\"gY1B8\",\"async.eeb23059.js\",\"1d7Ag\",\"arrow-up-right--open.a14764a1.js\",\"j4ThT\",\"link-broken--unlink.278d8021.js\",\"aL59j\",\"settings.6b2650c7.js\",\"dRYf3\",\"NativeCollabComponent.91717276.js\",\"fjOTL\",\"person-add.2ade7731.js\",\"2lFgQ\",\"NativeCollabComponent.321621e8.js\",\"gsVz2\",\"apple.ee886279.svg\",\"dD2UN\",\"avocado.8855629b.svg\",\"cJ1yJ\",\"badger.0fb3ff8d.svg\",\"7YUk9\",\"bat.3a3e8172.svg\",\"6X6by\",\"bear.6250dade.svg\",\"2sTIo\",\"beaver.72239cbc.svg\",\"i8nLS\",\"bee.1d8bfe50.svg\",\"gcIIm\",\"bison.4fe77735.svg\",\"f4w4P\",\"blossom.90b2a1c3.svg\",\"3M3TP\",\"blowfish.8afad7f1.svg\",\"jj7DM\",\"blueberries.688d225d.svg\",\"iNtB4\",\"boar.15310caf.svg\",\"8PMfG\",\"broccoli.fa9fd55e.svg\",\"bKhpH\",\"butterfly.f41d19d4.svg\",\"jIq81\",\"cactus.0c5c265c.svg\",\"kBI7V\",\"camel.6111d481.svg\",\"c7feZ\",\"candy.ffd5e59f.svg\",\"hxRJ0\",\"capsicum.30f76734.svg\",\"lX17f\",\"carrot.6193f6d7.svg\",\"8bxmK\",\"cat.154e1595.svg\",\"hA3FZ\",\"caterpiller.1b6fd239.svg\",\"gbZbF\",\"cherry.087938da.svg\",\"j9ADe\",\"chili.27401d1a.svg\",\"dFxlL\",\"clover.296ea840.svg\",\"2xCNX\",\"coconut.69480f00.svg\",\"2Efxt\",\"cookie.099bb841.svg\",\"evCT6\",\"corn.f527dc60.svg\",\"gFwow\",\"cow.e41482e6.svg\",\"2XMOh\",\"crab.39812367.svg\",\"5eMVW\",\"crocodile.221fa99c.svg\",\"10gCZ\",\"deer.3662e324.svg\",\"TQxkn\",\"dinosaur.e5c6efb5.svg\",\"eo3us\",\"dodo.a7114237.svg\",\"jQV0F\",\"dog.6630bd37.svg\",\"ac23h\",\"dolphin.3052ec02.svg\",\"dzpYA\",\"donut.e4649522.svg\",\"5yNNo\",\"dragon.4b6d8278.svg\",\"bD8nw\",\"duck.e8819dfa.svg\",\"hzpPe\",\"elephant.f64545b1.svg\",\"bIwt4\",\"fish.91063cf4.svg\",\"lwGqa\",\"flamingo.2d59f884.svg\",\"4yTHi\",\"fox.c1068dfa.svg\",\"fJzTu\",\"frog.4c69f05a.svg\",\"kABBu\",\"giraffe.65216e18.svg\",\"MkzSZ\",\"gorilla.51f05093.svg\",\"lnHGp\",\"grapes.6a50728f.svg\",\"5EWLH\",\"hedgehog.4cc9668b.svg\",\"dUp1W\",\"hippo.81684e99.svg\",\"aheBY\",\"kangaroo.099f9dd4.svg\",\"dkaeB\",\"kiwi.13ce1a05.svg\",\"1HXtV\",\"koala.730a01eb.svg\",\"cMwBU\",\"lemon.7d7dfe19.svg\",\"2BAKP\",\"lettuce.39b86ec6.svg\",\"e6bwN\",\"lion.191125b1.svg\",\"8T9yl\",\"lizard.de3c3103.svg\",\"cac7l\",\"llama.d767d641.svg\",\"5BEDg\",\"lobster.2b4a4d94.svg\",\"fJqqW\",\"mango.6b9252cb.svg\",\"lowPi\",\"melon.9c97f1e1.svg\",\"h4xnL\",\"monkey.423f2177.svg\",\"6u91g\",\"mouse.3d0aefe8.svg\",\"2F3Cf\",\"octopus.2c0d1056.svg\",\"kUtky\",\"olive.3e3e2c53.svg\",\"fMPgA\",\"orange.ed5e97f9.svg\",\"aPtir\",\"orangutan.9fa13362.svg\",\"56jGn\",\"otter.1b9e17fe.svg\",\"frA1K\",\"owl.13d3c4d9.svg\",\"eX5t5\",\"ox.0ed06fd3.svg\",\"fBa5s\",\"oyster.ad23795d.svg\",\"bb4eK\",\"panda.0b0047af.svg\",\"7Hf9L\",\"parrot.6fd92eec.svg\",\"jXyDw\",\"peacock.80ac60a6.svg\",\"h1wrP\",\"pear.c8d37fb0.svg\",\"2POSQ\",\"penguin.6577e559.svg\",\"7m3sL\",\"pig.2ba131ea.svg\",\"86Zta\",\"pineapple.61ebb967.svg\",\"gTsmW\",\"poodle.b40487d6.svg\",\"k4SDm\",\"rabbit.b4ce71c1.svg\",\"8lC4L\",\"raccoon.16b4372e.svg\",\"1pJw5\",\"rhino.6dcdebb2.svg\",\"98kgz\",\"robot.fdf311ba.svg\",\"43yj2\",\"rose.22a6e8e6.svg\",\"iS79i\",\"seal.de226e3b.svg\",\"8yJOq\",\"seedling.562f3bc0.svg\",\"kZ0aY\",\"shark.af44e0c5.svg\",\"fj6ga\",\"shrimp.116d9eea.svg\",\"acKhf\",\"skunk.a5578a4f.svg\",\"cMikt\",\"sloth.f3e9da22.svg\",\"kNMYF\",\"snail.06380b65.svg\",\"9l4Yo\",\"snake.3ead898b.svg\",\"8MdzK\",\"snowman.cdcd9574.svg\",\"5g22q\",\"squid.0638299b.svg\",\"c5Bpr\",\"squirrel.e3a31ee3.svg\",\"d1rix\",\"strawberry.4111dfb6.svg\",\"6FXUv\",\"sunflower.ff291a55.svg\",\"aI3CU\",\"tiger.2ba2da26.svg\",\"k58uj\",\"tomato.e755033f.svg\",\"b5j3b\",\"tree.e62f2602.svg\",\"49dFp\",\"t-rex.d85831fb.svg\",\"f5dcg\",\"tropical-fish.797d455e.svg\",\"i0A9l\",\"turkey.a79defab.svg\",\"2Wzpa\",\"turtle.acbe0058.svg\",\"eWBQ3\",\"watermelon.199e013c.svg\",\"01NgI\",\"whale.cc048b8e.svg\",\"hOBjY\",\"wolf.a39956da.svg\",\"jMBLi\",\"cs.ddae9418.js\",\"dKSPa\",\"da.64d7a394.js\",\"aNGGp\",\"de.e6825891.js\",\"16eqk\",\"en_GB.e64aae1f.js\",\"smHwh\",\"en_ZZ.082d44d7.js\",\"lLAhl\",\"es.e5ee9347.js\",\"7lUpZ\",\"fi.d34c6226.js\",\"iFuRL\",\"fr.1e887a2e.js\",\"bwpap\",\"hr.7d0f0fe4.js\",\"2qkmI\",\"hu.18cc074a.js\",\"kxYID\",\"it.e4315136.js\",\"iHsNL\",\"ja.c5f4132f.js\",\"jGOT0\",\"ko.42262b96.js\",\"3s5dS\",\"nb.65e698b8.js\",\"ffRdF\",\"nl.99bdf951.js\",\"bS9i1\",\"pl.61fd3c37.js\",\"3ydLu\",\"pt_BR.04f227e7.js\",\"lqmbR\",\"ru.ed18eb15.js\",\"3px1j\",\"sr_RS.0d21896f.js\",\"1NiRW\",\"sr_YR.16ae426a.js\",\"auBTD\",\"sv.f32c0d54.js\",\"fxn2i\",\"th.813bad48.js\",\"adwGb\",\"tr.db55a624.js\",\"guUGa\",\"uk.8aa3f38b.js\",\"9bAgX\",\"vi.b2fe404f.js\",\"HLzfe\",\"zh.d0ddd675.js\",\"in5qk\",\"zh_TW.c7df6946.js\",\"83pn3\",\"ObjectSidebarControl.9ca38c3d.js\",\"8S7hU\",\"ContentWrapperSpotlightGIF-dark.bbe9839d.gif\",\"7P169\",\"ContentWrapperSpotlightGIF-light.9900190e.gif\",\"29x7D\",\"MainButtons.dcab1065.js\",\"cUtrS\",\"WatchDialogWrapper.5f084173.js\",\"bCr24\",\"main.d42b43bc.js\",\"lp0cK\",\"both-splash.465c87c4.svg\",\"bo7LK\",\"teams-splash.36cc0781.svg\",\"8XHrw\",\"slack-splash.73e116f6.svg\",\"9OSao\",\"WatchDialogContent.27ca5a16.js\",\"8hbZ5\",\"WatchDialogShortcut.356dbcb6.js\",\"3yFtm\",\"WatchSettingsOverflowMenuShortcut.6b160d91.js\",\"iJwzY\",\"ManageWatcherDialog.bf2914a3.js\",\"kNrOB\",\"ContentTypesHeader.f4f29df0.js\",\"3YQfj\",\"MainButtons.4e3f093b.js\",\"iWKl1\",\"ScheduledStatus.3a7bdd1e.js\",\"jYr96\",\"DraftStatus.c886c69b.js\",\"bn8Oy\",\"OverviewNotFound.0aab681c.js\",\"4jFyQ\",\"icon-space-overview-empty.106059f9.svg\",\"getgv\",\"QuickActionsContent.8a8c9af5.js\",\"PNyg1\",\"InlineRename.3f19bc82.js\",\"19uFC\",\"pages.d69df670.js\",\"lVcuZ\",\"MovePageDialog.9f682235.js\",\"3L1uC\",\"PageTreeErrorComponent.13e06b8a.js\",\"ewwba\",\"PageTreeEmptyComponent.27a769b7.js\",\"dviIw\",\"CollapsibleSection.3c96aa03.js\",\"dhqJV\",\"FooterCreateButtons.fb6b4b4c.js\",\"67Pvd\",\"ContentTreeOnboarding.4da001b1.js\",\"e19Zv\",\"LiveDocsIconTile.c9b72704.js\",\"d1QkY\",\"TreeBottomCreateButton.6fe81837.js\",\"f9QHk\",\"TreeMonitor.bef0ea8b.js\",\"fnoJZ\",\"HomepageIcon.12230327.js\",\"6gau7\",\"DraftLozenge.6442dab1.js\",\"hHYS0\",\"ModernizedBreadcrumbsIndentIcon.7708ddee.js\",\"jZwEH\",\"ExitBranchDeploy.783a8683.js\",\"dUr0C\",\"FeedbackCollectorButton.4c9fb3e3.js\",\"avZlC\",\"BannerContainer.5fd322bb.js\",\"i4Poh\",\"DevToolsDialog.bad810df.js\",\"dUfIT\",\"OnboardingStateEditor.c8c4dfc5.js\",\"331QJ\",\"statsigIcon.d38e3090.png\",\"dKuGS\",\"switcherooIcon.4d3f783a.png\",\"C72jX\",\"DevToolsBanner.375d639a.js\",\"9mi9f\",\"BannerSpacer.db82d299.js\",\"fbsPn\",\"AdminAnnouncementBanner.01c65038.js\",\"eIzhm\",\"AdminAnnouncementBanner.b72c0adb.js\",\"cjDIz\",\"GracePeriodBanner.1398c896.js\",\"4uVag\",\"StorageEnforcementBanner.9456241c.js\",\"cGZdO\",\"PlanConsentDeepLink.e85c4404.js\",\"hmjlF\",\"ConsentBannerWrapper.434a9656.js\",\"fBYQ7\",\"browser-storage-controls.b856b24d.js\",\"gCbq8\",\"cs.a209aa14.js\",\"TR24h\",\"da.52144f35.js\",\"NfUyB\",\"de.189b802b.js\",\"4v21d\",\"en_GB.58bcc852.js\",\"4D2WV\",\"en_ZZ.07b6b0f2.js\",\"gSwbJ\",\"es.27061460.js\",\"chaHI\",\"fi.f05d4dc5.js\",\"kBpIt\",\"fr.d4774d68.js\",\"dPeMl\",\"hu.9a5436ee.js\",\"4PHEa\",\"it.8260474e.js\",\"CGYMd\",\"ja.514cf297.js\",\"fGpBg\",\"ko.09d46e0e.js\",\"cgWNw\",\"nb.593f98f0.js\",\"aUP3I\",\"nl.9e24e59e.js\",\"bs4gz\",\"pl.e0577981.js\",\"gSXrz\",\"pt_BR.1efcd373.js\",\"aJd4I\",\"ru.b8c2b1b7.js\",\"gR7fm\",\"sv.07219ae9.js\",\"xDkFq\",\"th.be4d9bd0.js\",\"cV2OA\",\"tr.7e1ff419.js\",\"ehLR6\",\"uk.86f0ff8b.js\",\"lXmbw\",\"vi.43447bab.js\",\"jwfyA\",\"zh_TW.fa40865e.js\",\"6zOB9\",\"zh.d323a517.js\",\"7ETma\",\"BannerContainer.9329098f.js\",\"jryQt\",\"GlobalComponents.691838f7.js\",\"atyNV\",\"CreateSpaceDrawer.4e1e9cc3.js\",\"dJhDI\",\"Upload.41b8806c.svg\",\"M5ILR\",\"batteriesBlueDark.307d9428.svg\",\"dnR9a\",\"batteriesBlueLight.58029d15.svg\",\"ixrb7\",\"batteriesYellow.e8d8df45.svg\",\"kGVcH\",\"bookGreen.5c165cdd.svg\",\"loqoo\",\"bookLightBlue.c5d525e7.svg\",\"7Olsp\",\"bookPurpleDark.bbc69ae5.svg\",\"6qyLp\",\"bookPurpleLight.50087e6b.svg\",\"ciCdw\",\"bookTeal.baf50001.svg\",\"bps3L\",\"bookYellow.01d134f1.svg\",\"d8nip\",\"chartPages.84c56718.svg\",\"aEEfr\",\"chatBubbles.752ee291.svg\",\"81Z0f\",\"clipboardBlue.1f41d5b1.svg\",\"4Yhmf\",\"clipboardGreen.ff6ef343.svg\",\"iYpOd\",\"clipboardPurple.a753e54b.svg\",\"3E2sU\",\"clipboardTealLight.23775816.svg\",\"kLu4e\",\"clipboardTealDark.a991e538.svg\",\"4fLmK\",\"cogYellow.be8df822.svg\",\"3wJ5M\",\"fileCabinetTeal.16f6f59f.svg\",\"a9GoZ\",\"frameBlueLight.5b2ffbc9.svg\",\"fEhU6\",\"frameBlueDark.31054afc.svg\",\"3fQrZ\",\"frameGreen.c926fe32.svg\",\"d6OX2\",\"frameRed.43830b0b.svg\",\"aKOqx\",\"frameYellow.139065bc.svg\",\"5Egzg\",\"gearsGreen.90d00858.svg\",\"j7vSR\",\"insightBlueDark.37b94f41.svg\",\"jPZce\",\"insightBlueLight.9abf8616.svg\",\"kfwXh\",\"insightPurple.2faf728d.svg\",\"dwYXe\",\"pageSearchLight.e58e2baa.svg\",\"dAUqn\",\"pageSearchDark.cd5f6733.svg\",\"4Ou3u\",\"powerfulSearchLight.876ff255.svg\",\"9Dfl4\",\"powerfulSearchDark.2139ba31.svg\",\"h1Fz9\",\"ribbonLight.803a1a85.svg\",\"jDFmh\",\"ribbonDark.6fe08399.svg\",\"6GKoK\",\"roadmapLight.b91d4299.svg\",\"2yafp\",\"roadmapDark.a889e2f2.svg\",\"luNRW\",\"rocket.df13335e.svg\",\"5sgCW\",\"sandThingRed.1afa3779.svg\",\"lUKys\",\"templatesLight.79fdbc2b.svg\",\"c6izM\",\"templatesDark.770532e7.svg\",\"4fscz\",\"skyBackground.807308bc.svg\",\"bjH6i\",\"blankThread.8cd5fcf5.svg\",\"5H38F\",\"teamThread.805f1c78.svg\",\"hPrsC\",\"documentationThread.87cb7cb5.svg\",\"h65C2\",\"knowledgeThread.4da53513.svg\",\"GkFQZ\",\"softwareThread.c63cbb64.svg\",\"l9S8D\",\"marketingTeamThread.5ea9534d.svg\",\"9DuCc\",\"designTeamThread.a51c8a49.svg\",\"7b7Le\",\"operationsTeamThread.7b099258.svg\",\"5pZXJ\",\"projectManagementTeamThread.80f46356.svg\",\"97cUe\",\"financeTeamThread.1a41b925.svg\",\"bdlYs\",\"customerSupportTeamThread.93301b92.svg\",\"4Yl3h\",\"legalTeamThread.ba24ce51.svg\",\"gEtqu\",\"salesTeamThread.d1bfc373.svg\",\"c9Wdy\",\"itTeamThread.f9d7c100.svg\",\"2Z9oz\",\"researchTeamThread.742bf70b.svg\",\"hFzEL\",\"hrTeamThread.80788d38.svg\",\"hlubS\",\"productManagementThread.09fb011d.svg\",\"7KLrf\",\"projectCollaborationThread.80f46356.svg\",\"30xR7\",\"knowledgeBaseThread.4da53513.svg\",\"89THn\",\"blankHeaderImage.b2e5214d.svg\",\"e5j6w\",\"blankContentImage.37095a6e.svg\",\"lTMbq\",\"teamHeaderImage.f7f582cf.svg\",\"5rLIC\",\"meepleAngie.b36359fa.svg\",\"1WpWA\",\"meepleGael.321f0541.svg\",\"iDRHz\",\"meepleClaudia.49596a7e.svg\",\"abhev\",\"documentationHeaderImage.4412b92c.svg\",\"2JPI5\",\"sparklesIcon.c88101af.svg\",\"kFXQS\",\"recentlyUpdatedIcon.12afe66f.svg\",\"byqYh\",\"labelIcon.fde8f3d1.svg\",\"4acnY\",\"knowledgeHeaderImage.363eba36.svg\",\"besIq\",\"slackIcon.09e5da26.svg\",\"4LUrg\",\"topicsIcon1.0989a9fb.svg\",\"ahJUE\",\"topicsIcon2.b604b777.svg\",\"a3Rwk\",\"topicsIcon3.ba5d4623.svg\",\"4FAMd\",\"topicsIcon4.ced48f1d.svg\",\"gLN2K\",\"topicsIcon5.49641d70.svg\",\"9GDpT\",\"topicsIcon6.e4b2d662.svg\",\"aBtfy\",\"softwareHeaderImage.192899c6.svg\",\"bIOUn\",\"jiraIssuesImage.98370f5b.svg\",\"byj7D\",\"roadmapImage.af494b5e.svg\",\"5RVPP\",\"marketingTeamHeaderImage.2c3873b0.svg\",\"9LOKa\",\"meepleAlvin.36da1ebc.svg\",\"26SB0\",\"meepleNarul.7730aaba.svg\",\"3mZbA\",\"meepleFabian.5c813638.svg\",\"8L112\",\"designTeamHeaderImage.c46a93d2.svg\",\"bqaRi\",\"meepleHasan.08dad2a0.svg\",\"3eEUG\",\"meepleEliot.64d467ec.svg\",\"TbeMm\",\"meepleMaribel.f2261c26.svg\",\"hEeW5\",\"meepleEffie.7847ff50.svg\",\"lxkYJ\",\"meepleHelena.63e4f930.svg\",\"fkCcV\",\"meepleEd.971a9eb8.svg\",\"da9cR\",\"operationsTeamHeaderImage.a14d17e5.svg\",\"41WRw\",\"projectManagementTeamHeaderImage.33a5a479.svg\",\"7lq4P\",\"financeTeamHeaderImage.1a730228.svg\",\"ivAmF\",\"meepleOliver.42b4efc7.svg\",\"hjCA9\",\"meepleSteve.03d2a4bb.svg\",\"6WsSL\",\"customerSupportTeamHeaderImage.c936930a.svg\",\"4a7nj\",\"meepleEffieSquare.2634dbda.svg\",\"8W0HV\",\"meepleTanya.5912be0f.svg\",\"lV74y\",\"meepleAngieSquare.3e93f6cc.svg\",\"19y9E\",\"legalTeamHeaderImage.4d7daac4.svg\",\"brcnK\",\"salesTeamHeaderImage.44ad8004.svg\",\"6wRd5\",\"itTeamHeaderImage.31c8b476.svg\",\"4Xo1Q\",\"researchTeamHeaderImage.1f6efccb.svg\",\"e3lCz\",\"hrTeamHeaderImage.e709f28b.svg\",\"59GCR\",\"productManagementHeaderImage.b0a18370.svg\",\"eDipp\",\"projectCollaborationHeaderImage.33a5a479.svg\",\"3oMbG\",\"knowledgeBaseHeaderImage.363eba36.svg\",\"4nr7V\",\"pageIcon.21c39749.svg\",\"jXgU3\",\"blogIcon.9747a79d.svg\",\"3FTtM\",\"meepleLydia.bed2d01d.svg\",\"7XX5f\",\"meepleKatina.172e1240.svg\",\"gmEwc\",\"meepleMilo.8a0e1272.svg\",\"61eGd\",\"meepleLara.c691a9bf.svg\",\"4Be4D\",\"meepleNorah.d4705d04.svg\",\"f1x0y\",\"flag.198afb7e.js\",\"eeaKR\",\"credit-card.39a2b6fa.js\",\"eEyVs\",\"book-with-bookmark.f202cd02.js\",\"cBy9y\",\"clipboard.d2ecfccd.js\",\"4o7bO\",\"CreateSpaceDrawer.aa07653a.js\",\"9JWXo\",\"ImportContentDrawer.300b7660.js\",\"5eYbH\",\"fileIconLight.5dfddb2d.png\",\"f27VQ\",\"fileIconDark.996a692c.png\",\"eQRZh\",\"alexander.61c8c5b8.png\",\"k3UTH\",\"milo.2bdab175.png\",\"bpNrn\",\"vania.0f716e7d.png\",\"1SbNU\",\"newUsersIcon.051e2f52.png\",\"4pzfE\",\"entireWorkspaceGraphic.ec7c84e3.png\",\"9EbOe\",\"entireWorkspaceGraphicDark.a2cf125d.png\",\"5v8ge\",\"pageWithSubpagesGraphic.bc63f39a.png\",\"l5ApQ\",\"pageWithSubpagesGraphicDark.048b0716.png\",\"e233E\",\"NotionFileIcon.bf57d29e.png\",\"2HswK\",\"NotionFileIconDark.1bce2172.png\",\"iHoZ2\",\"mapNotionMembersIcon.f5fa6c65.png\",\"mKUlU\",\"mapNotionMembersIconDark.78a4caee.png\",\"lve0S\",\"dontMapNotionMembersIcon.d4b46256.png\",\"fHhNe\",\"dontMapNotionMembersIconDark.8a5a6302.png\",\"idIGV\",\"addRemainingMembersIcon.ed292f87.png\",\"eFqPt\",\"addRemainingMembersIconDark.fcaa97df.png\",\"ahBHt\",\"dontAddRemainingMembersIcon.c16498ed.png\",\"bJ6Qx\",\"dontAddRemainingMembersIconDark.2a9fa7cf.png\",\"jO0Zn\",\"copyPagePermissionsIcon.893f44bc.png\",\"koH91\",\"dontCopyPagePermissionsIcon.57c83ce6.png\",\"4qS5d\",\"createNewSpaceIcon.43619a57.png\",\"7HrUn\",\"createNewSpaceIconDark.1df6e816.png\",\"rGPsx\",\"dontCreateNewSpaceIcon.b35b2829.png\",\"5a1S5\",\"dontCreateNewSpaceIconDark.706b6cfd.png\",\"8R1Rz\",\"spaceTransferLight.b2e70613.png\",\"1e1ep\",\"spaceTransferDark.856b3d0e.png\",\"jGDZO\",\"zipFileIconLight.5dfddb2d.png\",\"4pvad\",\"zipFileIconDark.996a692c.png\",\"4xmnl\",\"spaceTransferIconLight.0d0100d0.png\",\"aBnpB\",\"spaceTransferIconDark.ac15ec97.png\",\"aRCSw\",\"miroBulkImportIconLight.79569254.png\",\"dur8E\",\"miroBulkImportIconDark.8307c4bf.png\",\"eGDQk\",\"Miro_Connie_Light.97ddc4df.png\",\"5IkEQ\",\"Miro_Connie_Dark.588133c4.png\",\"d4y04\",\"muralSpacesIllustrationLight.297ed65c.png\",\"hgEBB\",\"muralSpacesIllustrationDark.a5d03bf9.png\",\"4YW3x\",\"inviteMembersIconLight.1a833efb.png\",\"jw4LE\",\"inviteMembersIconDark.1179e32a.png\",\"hoRD8\",\"newSpaceIconLight.9405f85d.png\",\"5ILSM\",\"newSpaceIconDark.ac15ec97.png\",\"2Q5QN\",\"muralIcon.75d8302a.png\",\"fK2sh\",\"muralSpacesIllustrationDisconnectedLight.4bd334a6.png\",\"3aNue\",\"muralSpacesIllustrationDisconnectedDark.a6cca434.png\",\"7MlKm\",\"archive.5e2679d9.js\",\"hX5aL\",\"ImportContentModal.a1d1cbfb.js\",\"dIKKx\",\"StorageEnforcementFlags.66a191a3.js\",\"52dqm\",\"GracePeriodModal.b4eb674d.js\",\"6sJUU\",\"GracePeriodModalComponent.86d3664c.js\",\"gKiqN\",\"gracePeriodIllustrationDark.e34dd459.svg\",\"02fAA\",\"gracePeriodIllustrationLight.04bd67a4.svg\",\"gIOIL\",\"BlockCreateModal.7540cb06.js\",\"fDkpP\",\"blockCreateIllustrationLight.10953577.svg\",\"36KWd\",\"blockCreateIllustrationDark.e6b33366.svg\",\"3CJXT\",\"rovo-video-modal.eac74805.js\",\"1oAGT\",\"shrink-diagonal.f22f633c.js\",\"2Gceu\",\"minimize.b3b85be5.js\",\"f9Wnm\",\"shrink-diagonal--media-services-fit-to-page.807104c9.js\",\"dj3mE\",\"ExperimentPlanSelectionModal.f51b7b32.js\",\"3AFNb\",\"illustrationStandard.3fd561a4.svg\",\"c7qkT\",\"illustrationBestValue.d42ec92a.svg\",\"cYTMv\",\"illustrationBestValueDarkMode.4db8a5eb.svg\",\"eRZ4m\",\"illustrationStandardDarkMode.d9f68860.svg\",\"gmwfN\",\"ModernizeChangeboarding.fb3ee094.js\",\"iZkNL\",\"Modal.93201c60.js\",\"4jvyy\",\"play-button.f16ed914.png\",\"bSWox\",\"thumbnail-light.cbc485ab.png\",\"espuV\",\"thumbnail-dark.4c2a9461.png\",\"7VEEc\",\"whiteboards.5bac062b.svg\",\"1S5Y4\",\"rovo-ai.1a901dc7.svg\",\"dZyP8\",\"reactions-and-stickers.1f3b4ebe.svg\",\"8VWrF\",\"jira-work-items.11443501.svg\",\"55agv\",\"loom-videos.37a4452c.svg\",\"jGjVz\",\"whiteboards-dark.5a9dae19.svg\",\"j77CV\",\"rovo-ai-dark.ac54f515.svg\",\"33gHJ\",\"reactions-and-stickers-dark.fd611bb0.svg\",\"eRF5i\",\"jira-work-items-dark.f74ce1c2.svg\",\"crbaY\",\"loom-videos-dark.1afab585.svg\",\"8GTC6\",\"Modal.3702f594.js\",\"31kOm\",\"nav4GlobalSpotlightImage.b0eee534.svg\",\"dW3gq\",\"nav4GlobalSpotlightImageDark.46829a6e.svg\",\"1aHOD\",\"nav4SpaceSpotlightImage.8dc1626b.svg\",\"huVSt\",\"nav4SpaceSpotlightImageDark.eeaa5b5d.svg\",\"iXULO\",\"LiveDocModalGif-light.2404511f.gif\",\"ff6Qm\",\"LiveDocModalGif-dark.64c94d68.gif\",\"fQKYr\",\"ConfluenceSmartCreationModal.bec4c5a5.js\",\"9gDvs\",\"accessibility.5564f20e.svg\",\"f4pjt\",\"award.214f8776.svg\",\"1A7In\",\"calendar.b3d986a4.svg\",\"hbmJV\",\"checklist.73c2b414.svg\",\"dfz72\",\"community.e0696574.svg\",\"8iDBX\",\"customer.b92e93e7.svg\",\"g9qwo\",\"develop.57b4f578.svg\",\"5MnfW\",\"flowchart.a71ff7c1.svg\",\"92hcC\",\"guidelines.997e35c4.svg\",\"YpFw7\",\"hire-writer.de7ada5b.svg\",\"hPfyy\",\"icons-gears.bfd13e5a.svg\",\"4d6gC\",\"icons-people.f158a567.svg\",\"ckHEC\",\"illustrations.98e8bf43.svg\",\"iXa6x\",\"lightbulb.e4ffc69c.svg\",\"lA2m1\",\"marketing.2c92f054.svg\",\"9DSi1\",\"onboarding.43d000af.svg\",\"69pz5\",\"project-management.8376933a.svg\",\"bFaEu\",\"release-phases.4229641f.svg\",\"4HRl6\",\"resilience.4a0de1ce.svg\",\"kyaih\",\"system-of-work.579d0af3.svg\",\"avXjM\",\"tips.695c0031.svg\",\"g7RCN\",\"trust.ae24e421.svg\",\"klZVQ\",\"user-testing.1d397bb2.svg\",\"aSfft\",\"vision-values.6d647ce6.svg\",\"bDavb\",\"volunteering.f0465fb3.svg\",\"7iOBS\",\"ConfluenceCreateIllustrationLight.e6af8be5.svg\",\"gNGuh\",\"ConfluenceCreateIllustrationDark.6237fca1.svg\",\"8fTZe\",\"GlobalComponents.cb63a125.js\",\"lz2pE\",\"EditionAwarenessUpsell.fc164160.js\",\"eWCiQ\",\"standard-to-premium-modal.6e60aa2a.js\",\"becB8\",\"on-call.39b97377.js\",\"gjVBG\",\"devices.13a157d4.js\",\"hUapU\",\"StandardToPremiumModal.edc82e58.js\",\"99Yp3\",\"standard-to-premium-modal.94320686.js\",\"gobtw\",\"cs.f2325b58.js\",\"4XclW\",\"da.8823548e.js\",\"5FpC5\",\"de.9f8c75dc.js\",\"Z7F9W\",\"en_GB.88145e4b.js\",\"5vJlz\",\"en_ZZ.6e66d65b.js\",\"kqbLA\",\"es.ebafda9e.js\",\"2xTUv\",\"fi.e29037f1.js\",\"ke5Ak\",\"fr.c635078e.js\",\"78Xv1\",\"hu.36e2e3d5.js\",\"9WYDz\",\"it.b621bab0.js\",\"14Xp5\",\"ja.00759942.js\",\"5YZ43\",\"ko.cb3af28f.js\",\"hcAAz\",\"nb.cd8afc0a.js\",\"a3CGb\",\"nl.7356521a.js\",\"3jRvQ\",\"pl.7af8622a.js\",\"3eKFX\",\"pt_BR.24688c8c.js\",\"2cWJ7\",\"ru.b416633d.js\",\"7io6v\",\"sv.370b80d6.js\",\"bcDrQ\",\"th.aaf28806.js\",\"23xaC\",\"tr.5a5f7532.js\",\"dBkXE\",\"uk.f9026017.js\",\"fQKkM\",\"vi.09fcf459.js\",\"cXjwK\",\"zh_TW.2cb7259f.js\",\"fCfjN\",\"zh.9966cb4b.js\",\"6KFfh\",\"credit-card--creditcard-filled.b29fbb0e.js\",\"dIqAs\",\"EditionAwarenessUpsell.d6d14b91.js\",\"9CRBg\",\"StandardToPremiumModal.1d9bdec1.js\",\"hXnsV\",\"cloud-arrow-up.92b3e89c.js\",\"hriIn\",\"GlobalComponents.e9c662cb.js\",\"aIwO0\",\"cs.f956678d.js\",\"iwseV\",\"da.1ed5eea1.js\",\"eh9w8\",\"de.82932f6a.js\",\"3eWGu\",\"en_GB.74819150.js\",\"7SsCP\",\"en.d967223f.js\",\"8jVst\",\"en_ZZ.a3d864e6.js\",\"hNk7k\",\"es.590ddc01.js\",\"arXo9\",\"fi.6ff3a1bd.js\",\"yuLnu\",\"fr.a2c1ed73.js\",\"2pQv8\",\"hu.eeeb0120.js\",\"jGBo1\",\"it.6c68996f.js\",\"eUrwV\",\"ja.58f2839e.js\",\"2zgDh\",\"ko.16c5c892.js\",\"bETPT\",\"nb.496e500b.js\",\"ceBZg\",\"nl.73a69798.js\",\"5STWe\",\"pl.0e7b9c98.js\",\"EfE3i\",\"pt_BR.eaeaa31f.js\",\"hFqXA\",\"ru.9fd45835.js\",\"4ArgV\",\"sv.e5111a3e.js\",\"28EDH\",\"tr.2694d722.js\",\"k3mTs\",\"th.c07453ad.js\",\"jJdZ4\",\"uk.e043a262.js\",\"eZRzs\",\"vi.ea598b71.js\",\"bLQZ9\",\"zh_TW.0a8a067e.js\",\"e0E8p\",\"zh.c7ff8f80.js\",\"b2zon\",\"loom-cross-join-nudge.79e93dbf.js\",\"7rE1n\",\"msr-nudges.ce5a4de4.js\",\"2KxLg\",\"SideNavBannerImage.70db4b3d.svg\",\"aYgZt\",\"SpaceNavigation.5fe64703.js\",\"TkY5q\",\"RtPaidFeatureEducationSpotlight.27cfca4a.js\",\"cJHFd\",\"Nav3SpaceNavigationContent.d890e1d1.js\",\"h2810\",\"PersistentInvitePeopleButton.e0862093.js\",\"kyxdN\",\"EditSpaceLogo.4ede64ee.js\",\"gRwHT\",\"EditSpaceLogoComponent.6c97442a.js\",\"7t2Ec\",\"EditSpaceLogoGallery.9814d897.js\",\"860dT\",\"SpaceHeaderExCoOnboarding.14925977.js\",\"9H1r6\",\"GraphBarIcon.7958a840.js\",\"19Ali\",\"GridIcon.74b13c85.js\",\"hI11K\",\"AutomationNavigation.779201d1.js\",\"4skpM\",\"AutomationChangeBoarding.5d0b3d30.js\",\"8xPy6\",\"SmartButtonIllustration.b4b7c8dc.png\",\"fbDZw\",\"QuestionsNavigation.ef37bb09.js\",\"c0OU0\",\"QuestionsIcon.f035cca1.js\",\"7Qxu7\",\"TeamCalendarNavigation.695b5616.js\",\"aZ9pO\",\"CalendarIcon.3a9d12c0.js\",\"5DqrE\",\"BulkToolsNavigation.bc4887d3.js\",\"hHrTM\",\"edit-bulk.40121784.js\",\"klGUa\",\"ErrorView.c58f780f.js\",\"j0beU\",\"EyeStrike.801ddb27.svg\",\"eWlhh\",\"Nav3SpaceApps.b8641c17.js\",\"hs6o8\",\"SpaceAppsConfiguration.aa6d93d4.js\",\"6vEb6\",\"PageLayout.5ee47305.js\",\"X678k\",\"PageLayout.aeee9ffa.js\",\"69dSh\",\"choreographerRegistry.b83df159.js\",\"kDPsc\",\"render.1e69d210.js\",\"jdjSr\",\"render.a487eceb.js\",\"j4CTh\",\"tasks.4e573bd1.js\",\"8H49b\",\"PageLayout.7ed46465.js\",\"bl22g\",\"notes.fb6dd43b.png\",\"dAcu4\",\"ai-notes-icon.f866806e.svg\",\"6KfIh\",\"Nav3SpaceNavigationContent.c4dcd045.js\",\"1NnjK\",\"ShortcutsSection.72c04afb.js\",\"aBvTF\",\"ShortcutsDragContainer.9df3c1c5.js\",\"i0VYb\",\"root-component.d99263a3.js\",\"kBLei\",\"PersistentCollapsibleSection.488fcf63.js\",\"5TCys\",\"SpaceViews.c7a84ab0.js\",\"aCG0y\",\"SpaceViewsErrors.5e3f4c08.js\",\"5qLBt\",\"SearchNoResultLight.8777776b.svg\",\"6KUsM\",\"SearchNoResultDark.50b7a17f.svg\",\"1TYNY\",\"SpaceViewsCurrentViewIndicator.582c2041.js\",\"guX1n\",\"ViewMoreButton.a28c4578.js\",\"kJLy8\",\"SpaceViewsList.f9380a79.js\",\"60m6Z\",\"analyticsCallbacks.dbad6de8.js\",\"6gmSt\",\"PagesItemActions.664ca1af.js\",\"3HpiM\",\"BulkActionsChangeboardingSpotlightInner.39f505cf.js\",\"3YKnT\",\"bulkActionsChangeboardingSpotlightImage.9c36fbc8.svg\",\"fC3D2\",\"SpaceViewsMenu.97fd6b5b.js\",\"cWvhX\",\"PageOwnershipByLineWithContributorsDropdownContent.4ebc2d18.js\",\"eQlG4\",\"ContentTreeSearch.a4166a54.js\",\"3ZZtq\",\"ContentTreeSearchStates.15410ea4.js\",\"cQVtz\",\"SpaceHoverPageCard.d784ab77.js\",\"1HMdt\",\"EndOfPageRecommendation.36dbecb9.js\",\"hDNUK\",\"BlogTree.34c15bf4.js\",\"lnCW7\",\"ExternalCollaboratorInSpaceNotify.b3f7f319.js\",\"hFtKc\",\"SpaceNavigationContent.23f72747.js\",\"c08ou\",\"CalendarsLink.24f738e9.js\",\"8uhuz\",\"QuestionsLink.7672f4bf.js\",\"kZjBp\",\"SpaceApps.b377ba3d.js\",\"e2ujj\",\"eye-open-filled.c4b25411.js\",\"6jw5Q\",\"chart-trend.1489503f.js\",\"5E6oP\",\"AutomationOnBoarding.58cca104.js\",\"1TfYn\",\"AutomationLight.3a471294.png\",\"5ZTDJ\",\"AutomationDark.427f07ad.png\",\"cD5e0\",\"GlobalNavigationComponent.23641fff.js\",\"03aeW\",\"en_GB.21088f7b.js\",\"6nK39\",\"th.21f733a6.js\",\"hWNfo\",\"tr.db7fac89.js\",\"8UuQQ\",\"uk.78edbc55.js\",\"6BkMx\",\"vi.d59c3bda.js\",\"03cvv\",\"errorWarning.3a015e54.svg\",\"dvjk6\",\"noResultsDark.90199792.svg\",\"57B0v\",\"noResultsLight.5ffcf568.svg\",\"2yM8Y\",\"RecentContentMenu.86b166fa.js\",\"b3B6t\",\"coffeeChat.72f8b026.svg\",\"dbIft\",\"emptyStarBox.3b01bf42.svg\",\"9jGiN\",\"DiscoverSection.d6022acb.js\",\"brnyq\",\"miro.cb595030.png\",\"1IPtO\",\"slack.ba8f92ff.png\",\"gSraM\",\"invision.8f2e37e4.png\",\"8b1I3\",\"google-drive.d0028a0e.png\",\"6bVkQ\",\"lucidchart.8807407a.png\",\"kIryJ\",\"NotesMenu.d2e615c5.js\",\"j6C8t\",\"notepad.29a984bb.svg\",\"FBIp4\",\"TeamsAppShortcutItem.a66de542.js\",\"borwc\",\"CustomizationModal.cbc2c186.js\",\"6XoCv\",\"grow-vertical.e1a3c29e.js\",\"1VNI4\",\"CustomizeSidebarDialog.f1dfef65.js\",\"81eQE\",\"hashtag.01b327f2.js\",\"jNoHj\",\"GlobalNavigationComponent.7b9f87c1.js\",\"aGsq7\",\"companyHubItemCallback.cef73aa4.js\",\"7JfxY\",\"SpacesDropdown.1e799c6b.js\",\"a1VZ3\",\"GlobalNavigationComponent.2398be06.js\",\"hmXd6\",\"fileCabinet.17ae0554.svg\",\"17BHA\",\"noResultsDark.90199792.svg\",\"7S3sF\",\"noResultsLight.5ffcf568.svg\",\"geh8r\",\"AdminNavigation.cdf69de2.js\",\"2LUls\",\"ExploreAdminTools.2913e837.js\",\"6folH\",\"ExploreAdminTools.1376fd18.js\",\"7RWJk\",\"troubleLoading.cdf95244.png\",\"8s35j\",\"SpaceRolesLozenge.e2ce2326.js\",\"4rKYa\",\"person-added.bc078926.js\",\"gRwQ3\",\"cash.f61073db.js\",\"830Zv\",\"HubSettingsNavigation.eaef4e3f.js\",\"4vd0S\",\"NavigationBanner.fcc7bce6.js\",\"h4AS7\",\"EditionsIcon.5b4a5733.svg\",\"fSc0b\",\"Nav4CollapseReminderSpotlight.2efa3ca4.js\",\"3WCRn\",\"NewKeyboardShortcutsDialog.e05f5b47.js\",\"4AAsh\",\"AddPersonalSpaceDialog.1e74017c.js\",\"cbb8R\",\"megaphone.ea49a10b.svg\",\"7enLt\",\"clipboard.6bbe40ee.svg\",\"irkOO\",\"nameTag.1bdcf89f.svg\",\"8H6xE\",\"EditionAwareness.097b4d69.js\",\"1AVLS\",\"automation-free-limit-modal.b1b9c790.js\",\"1Bzn5\",\"breached-icon-dark-mode.c76c5af4.svg\",\"4li5B\",\"breached-icon.604210d1.svg\",\"5Hb8k\",\"gestural-line-dark-mode.0238cd16.svg\",\"fKxeV\",\"gestural-line.c0eb7c9f.svg\",\"7REXs\",\"automation-danger-icon.9e7c0e3a.svg\",\"7NqPm\",\"automation-warning-icon.0d3ef917.svg\",\"aMOuo\",\"collection-add-payment-details-popup.906bbd44.js\",\"1M56y\",\"add-payment-details-background.3806015e.svg\",\"b02wj\",\"credit-card--creditcard.1e46df2b.js\",\"99wAt\",\"collection-change-plan-popup.fa9a8e31.js\",\"7ZV49\",\"change-plan-background.3806015e.svg\",\"48HMF\",\"clock--recent.d917c73b.js\",\"d5GFk\",\"educational-discount-modal.37b3c649.js\",\"ap5E9\",\"educational-discount-offer.86ae350b.svg\",\"gctwz\",\"shield.3f7ae2d2.js\",\"dGvEg\",\"feature-onboarding-modal.58921565.js\",\"39fCS\",\"background-dark.a3b81b65.svg\",\"hlyBg\",\"background.335ae0da.svg\",\"ltJpU\",\"blue-box.4faddac8.svg\",\"lq3Sl\",\"free-choose-your-edition-modal.9db2ac82.js\",\"iI6Q4\",\"free-to-standard-modal.d9fbcf65.js\",\"jr06u\",\"jsw-add-people.17946c9a.svg\",\"jTG5T\",\"jsw-increased-storage-limits.b8a08bb1.svg\",\"iNU7h\",\"increased-storage-limits.a7321574.svg\",\"15Vzp\",\"unlimited-creators.3de71904.svg\",\"i0M9R\",\"help-desk-attachments-darkmode.a8bd959e.svg\",\"9zK71\",\"help-desk-attachments.138601ac.svg\",\"2hde5\",\"jsm-service-collection-add-people-darkmode.290a8179.svg\",\"j99t9\",\"jsm-service-collection-add-people.8f940b7d.svg\",\"anVlQ\",\"jsm-increased-storage-limits.21bb9c1c.svg\",\"cYQGZ\",\"unlimited-agents.743019a8.svg\",\"7jH9e\",\"location.6c7fcf6a.js\",\"1B0KU\",\"lock-unlocked--unlock.75fcd67e.js\",\"aE4di\",\"phone.b88e8f90.js\",\"aSXmO\",\"free-to-standard-modal.c881a637.js\",\"2zp5o\",\"background-dark.46d9946a.svg\",\"eGZ7X\",\"background-light.c76a8e81.svg\",\"2kbQr\",\"discovery-background-dark.73b58e40.svg\",\"8LjMq\",\"discovery-background-light.e5db6720.svg\",\"7qqQA\",\"gestural-line-dark.5fb5d96c.svg\",\"jmfnZ\",\"gestural-line.8591d4ac.svg\",\"1D15t\",\"free-to-standard-refresh-modal.53b82b5a.js\",\"de9xI\",\"background-light.c5aca943.svg\",\"mSvEe\",\"gestural-line-star-4.7814368e.svg\",\"aKXvR\",\"payment-details-popup.e8e325f3.js\",\"kwFai\",\"background.b3afa1bc.svg\",\"cDKlY\",\"plan-selection-page-modal.c178b9bf.js\",\"4JtX7\",\"premium-add-payment-modal.a6b09e40.js\",\"ki3nq\",\"premium-popup.1158f04e.js\",\"czatF\",\"premiumPopupHeader-Dark.8772bafb.svg\",\"8oiny\",\"premiumPopupHeader-Light.587e53c0.svg\",\"7YE3I\",\"reverse-trial-popup.52da7bab.js\",\"iFA9H\",\"special-offer-sixty-modal.fc66a368.js\",\"3KKo2\",\"background.cfd6bca5.svg\",\"1j7i8\",\"gestural-line-signal-4.2ed74c75.svg\",\"abLmz\",\"gestural-line-star-4.7814368e.svg\",\"kyUks\",\"radio-unchecked.a80b0bc5.js\",\"3opZo\",\"radio-checked.bfe4f2a4.js\",\"eCMUX\",\"standard-add-payment-modal.92b41f23.js\",\"lmoGI\",\"confluence-add-people.95d7cd0c.png\",\"1JrC5\",\"confluence-guest-access.0a003025.png\",\"cfLGc\",\"confluence-page-insights.548fcd17.png\",\"3DLtA\",\"confluence-page-restrictions.6ddf91dd.png\",\"dp0gI\",\"attachments.a7321574.svg\",\"7XFVr\",\"help-desk-attachements.21bb9c1c.svg\",\"7RlGN\",\"jpd-add-people.3de71904.svg\",\"4jaDc\",\"jsm-add-people.743019a8.svg\",\"kVhCr\",\"jsw-add-people.17946c9a.svg\",\"ksfeV\",\"standard-trial-limit-breakers-modal.8f300c04.js\",\"lLln8\",\"storage-hard-limit-modal.b6b6c9cb.js\",\"aCxGF\",\"storage-limit-breached-icon-dark-mode.c76c5af4.svg\",\"9WLSk\",\"storage-limit-breached-icon.604210d1.svg\",\"7hYpO\",\"storage-limit-danger-icon.9e7c0e3a.svg\",\"e2946\",\"PremiumTrialOnboardingModal.de2d5daf.js\",\"78YgQ\",\"Illustration.bc0cbd7b.svg\",\"bKgRA\",\"Illustration.bc0cbd7b.svg\",\"5CaYW\",\"video-play.924440ef.js\",\"dJC82\",\"DeleteSpaceDialog.291fea14.js\",\"4ukY5\",\"AboutConfluenceDialog.e87bb059.js\",\"6wPv6\",\"GiveFeedbackDialog.e4bc8e1d.js\",\"943D1\",\"ThemePopupMenu.30e3c46f.js\",\"9HjCR\",\"theme-light-thumb.1c8784c4.svg\",\"75cX5\",\"theme-dark-thumb.996efaf5.svg\",\"fc8cx\",\"theme-system-thumb.a357a448.svg\",\"kNFat\",\"ImpersonationFlag.08015697.js\",\"ciAVN\",\"spotlight.412515a1.js\",\"gaYsU\",\"PageLayout.ffe43a35.js\",\"hEkXc\",\"en-US.c2f93eaf.js\",\"6oOC9\",\"en-XA.bc152d24.js\",\"le1sE\",\"en-XB.3f7bafff.js\",\"oUCro\",\"hr.665c3168.js\",\"bJMZS\",\"sl.36363fa9.js\",\"exiT6\",\"sr-RS.3450f456.js\",\"jLkRH\",\"sr-YR.99ef1f81.js\",\"dmrYq\",\"sr.7f38330b.js\",\"g5LV7\",\"th.65f9a81b.js\",\"2QtDQ\",\"uk.bbf7d59a.js\",\"i2vEA\",\"vi.e39f9adb.js\",\"koawN\",\"en-US.8577a1a6.js\",\"6htQT\",\"en-XA.2be0bbd0.js\",\"fi75i\",\"en-XB.40aab55c.js\",\"36XYg\",\"hr.ea791c71.js\",\"7Rbde\",\"sl.9bd17812.js\",\"l8auu\",\"sr-RS.de35f66e.js\",\"3ColL\",\"sr-YR.6d75fa4f.js\",\"2VSOH\",\"sr.cbf031a6.js\",\"kyBJI\",\"th.ea68a7ea.js\",\"ahhGv\",\"uk.13d42b80.js\",\"1Zesg\",\"vi.e3d9da82.js\",\"fbIIm\",\"en-US.0fcdf1ae.js\",\"7l3it\",\"en-XA.3e6fbb90.js\",\"i64HJ\",\"en-XB.8100ddf0.js\",\"eQZk8\",\"hr.e3f3497b.js\",\"glLvq\",\"sl.93d481e6.js\",\"fFGjZ\",\"sr-RS.ddc08819.js\",\"fEAqG\",\"sr-YR.289dc38a.js\",\"e9tHh\",\"sr.14f31eee.js\",\"fTPgj\",\"th.4d360fb6.js\",\"lKa7i\",\"uk.38ddf7bc.js\",\"9aufD\",\"vi.4cc44e33.js\",\"dEcOC\",\"AnalyticsDialog.04504140.js\",\"5LCFM\",\"esm.70fc029a.js\",\"bvkZd\",\"no-results-dark.a00ae47b.svg\",\"cV42Q\",\"no-results-light.5ca83755.svg\",\"31zRr\",\"PageLayout.ac9b4a3f.js\",\"cvXSy\",\"RightPanel.c4284cc9.js\",\"iOFzT\",\"HelpPanel.00719ca0.js\",\"b3xzh\",\"LICENSES.c052b0cc.js\",\"j2bbk\",\"flask.4abe7595.js\",\"1Qnbg\",\"device-mobile.e5585656.js\",\"llPKJ\",\"lightbulb.f6b5fe08.js\",\"9mBQe\",\"feed.e134a1f8.js\",\"jSJrn\",\"eye-open--watch.f3840828.js\",\"c2Cby\",\"NotesSidebar.6595c24d.js\",\"1nKqs\",\"NotesModal.273c9db9.js\",\"7149U\",\"Arrow-Image.65dd605e.svg\",\"j0sJu\",\"NoResultsImage.d0ce8889.svg\",\"e4wOQ\",\"modal.f0326caf.js\",\"jFgF9\",\"FullPageEditorComponent.aebd9548.js\",\"87Teh\",\"syncedBlock.9f67d815.js\",\"e30RR\",\"FullPageEditorComponent.2a631732.js\",\"cBJyC\",\"FullPageEditorComponent.runtime.dc1afe35.js\",\"g5HUX\",\"CommentEditor.5d4d8290.js\",\"3n1YI\",\"NotesSidebar.37f7ef8c.js\",\"cBJyC\",\"FullPageEditorComponent.runtime.dc1afe35.js\",\"tKhaz\",\"CommentEditor.08fbe619.js\",\"3uAjk\",\"PageContentRendererFabric.fbe7476a.js\",\"fdmPa\",\"PageContentRendererFabric.runtime.5a583c3b.js\",\"1YQoH\",\"FullPageEditorComponent.dd3e3961.js\",\"fdmPa\",\"PageContentRendererFabric.runtime.5a583c3b.js\",\"8dYdP\",\"BranchDeployLogo.766bd5ee.js\",\"beF0E\",\"formatRelative.6270d915.js\",\"bkswC\",\"FeatureFlagLogo.85f80d3e.js\",\"5j5Dl\",\"NotificationsContent.e27701c7.js\",\"dxwAu\",\"emoji-add.daa0891c.js\",\"kiGNy\",\"render.85e31a85.js\",\"lCT7Q\",\"GoalPanel.53b3f41d.js\",\"aCjO7\",\"NotificationsContent.bcb96f86.js\",\"8jKp2\",\"main.c0c19225.js\",\"6xBPW\",\"toolbox-background.8cac0d99.svg\",\"cqJPj\",\"cs.f13ec029.js\",\"k8s3i\",\"da.4e35a524.js\",\"4wXhf\",\"de.a2bc61ae.js\",\"6tXZg\",\"es.7d8b4b59.js\",\"ktJwC\",\"fi.22ac2c85.js\",\"7mgkS\",\"fr.ee2905d4.js\",\"fWDE2\",\"hu.33549323.js\",\"b2OUm\",\"it.c36cfe38.js\",\"9PhiM\",\"ja.820fabd6.js\",\"4d3pr\",\"ko.e0e91139.js\",\"duoZ2\",\"nb.cd2ae6ec.js\",\"7JbfU\",\"nl.60ca1efa.js\",\"k9Hsp\",\"pl.5dfa7111.js\",\"dNbgl\",\"pt_BR.9cb9b72b.js\",\"53dLt\",\"ru.1df08e33.js\",\"dCa0R\",\"sv.89aedbdb.js\",\"dR545\",\"tr.d04aa5f9.js\",\"gIlXN\",\"th.0850867f.js\",\"ktxue\",\"uk.9deaceaa.js\",\"db0Tb\",\"vi.de756b2f.js\",\"cknqz\",\"zh_TW.65d91506.js\",\"8XnIU\",\"zh.77172dfb.js\",\"44Ne1\",\"main.966a268a.js\",\"bZ7A8\",\"main.2905d539.js\",\"bP7LP\",\"check-circle--check-circle-outline.d7572606.js\",\"52WuW\",\"show-more-vertical--more-vertical.3fff291a.js\",\"3xuDK\",\"show-more-vertical.91054f89.js\",\"5Qjce\",\"shortcut-pro-tip.65d378ae.js\",\"3VL8p\",\"arrow-down.5455dd41.js\",\"j5Z6Q\",\"main.9340f859.js\",\"eFvBU\",\"generic-error.74ae12d9.js\",\"19qJC\",\"avatar-group.f7644992.js\",\"brzrr\",\"main.063fc2b1.js\",\"kTdzk\",\"ObjectSidebarControl.679eb767.js\",\"8Z2Eu\",\"main.710e234f.js\",\"1y1ll\",\"main.870d36cb.js\",\"eYBaa\",\"main.909df6a3.js\",\"dGO6Y\",\"QuickReload.943c5f20.js\",\"aJ5As\",\"main.34f221e9.js\",\"27Dzv\",\"dark-mode.c2768bcf.svg\",\"1gUFj\",\"light-mode.e7c3914f.svg\",\"8s2Uo\",\"match-browser.a2bb9bea.svg\",\"49f46\",\"cs.077e9f4c.js\",\"jQPB7\",\"cs_CZ.02a4f979.js\",\"88bR1\",\"da.f100d419.js\",\"bwD1u\",\"da_DK.87972b77.js\",\"85kOD\",\"de.1d9843a9.js\",\"R2BG5\",\"de_DE.c262d848.js\",\"2goda\",\"en_GB.dbcbc037.js\",\"gjxqp\",\"en_ZZ.44473633.js\",\"1S2jF\",\"es.c17cb0b0.js\",\"eERmJ\",\"fi.4fa64611.js\",\"8rk64\",\"fi_FI.3920d863.js\",\"bpktO\",\"fr.903b8e7a.js\",\"aC2ty\",\"fr_FR.55477104.js\",\"lmJBr\",\"hu.531afc04.js\",\"lVBNt\",\"hu_HU.482ed985.js\",\"lnHpS\",\"it.87f71de5.js\",\"kEBAh\",\"it_IT.6068682f.js\",\"3ZAy1\",\"ja.94bc339c.js\",\"fDXOw\",\"ja_JP.b9c5af46.js\",\"45dhs\",\"ko.1eee672d.js\",\"grGen\",\"ko_KR.2eefe595.js\",\"4iqE9\",\"nb.2f604276.js\",\"bAyJY\",\"nb_NO.0e1c1672.js\",\"51EOq\",\"nl.6cc51681.js\",\"d5GjE\",\"nl_NL.36ecf941.js\",\"4ILPZ\",\"pl.1d15f5b3.js\",\"6QVYs\",\"pl_PL.4b70058e.js\",\"7HuII\",\"pt_BR.2b035f6a.js\",\"iYxvq\",\"ru.c3f08be2.js\",\"8kHli\",\"ru_RU.b5aa2be7.js\",\"dqRWB\",\"sv.937a087d.js\",\"bYWK5\",\"sv_SE.708683d2.js\",\"k0u9s\",\"th.1046cb5c.js\",\"imObn\",\"th_TH.951654d3.js\",\"chSc4\",\"tr.c7d5b86f.js\",\"dfeY8\",\"tr_TR.38e54197.js\",\"fvaoj\",\"uk.628c902d.js\",\"lT1ej\",\"uk_UA.7f80708f.js\",\"8OH5J\",\"vi.60bec7b2.js\",\"hV9Rr\",\"vi_VN.3f64294f.js\",\"k4zbq\",\"zh.74d31329.js\",\"1cNBX\",\"zh_CN.2e8ebc6e.js\",\"ii6TT\",\"zh_TW.222165d8.js\",\"Z6x4Y\",\"PageLayout.63c137cc.js\",\"7MnLd\",\"PageLayout.95e04880.js\",\"6XyGC\",\"atlassian-switcher.75bc73c2.js\",\"4NUCi\",\"cs.8ebee097.js\",\"cSX69\",\"da.231e3a08.js\",\"deZYh\",\"de.cf1b862d.js\",\"kU59n\",\"en_GB.86c05959.js\",\"1L3Og\",\"en_ZZ.f8d04e24.js\",\"6HKYn\",\"en.cf43cad0.js\",\"UHyLS\",\"es.91313863.js\",\"7jCUc\",\"et.1dd8203e.js\",\"jq5xm\",\"fi.bd97b000.js\",\"anfIJ\",\"fr.b2a9702c.js\",\"369Q4\",\"hu.8c305237.js\",\"1vaU3\",\"is.5d4b1a56.js\",\"23Iwb\",\"it.ecc65d29.js\",\"fFLzH\",\"ja.d0121fc7.js\",\"hVd5u\",\"ko.55a5744e.js\",\"lz5E6\",\"nb.2ab27b18.js\",\"bdV9c\",\"nl.cf9096f6.js\",\"eDHUW\",\"pl.96ae55ca.js\",\"RmhvD\",\"pt_BR.0c7c7669.js\",\"dAgm7\",\"pt_PT.fb4e7968.js\",\"f7XN4\",\"ro.17474067.js\",\"bA1DV\",\"ru.6714ef7c.js\",\"5Zouf\",\"sk.a983b13a.js\",\"f6c6x\",\"sv.b4fb6c92.js\",\"6VL5F\",\"th.2f11e26c.js\",\"9zarI\",\"tr.f399af48.js\",\"gtgoF\",\"uk.8db7671e.js\",\"kkSDy\",\"vi.02bc865d.js\",\"fgDwh\",\"zh_TW.7903df54.js\",\"j25uO\",\"zh.c83667eb.js\",\"dPH9c\",\"PageLayout.e5039829.js\",\"2PUw9\",\"robot-error.9b710643.js\",\"lxkzL\",\"atlassian-switcher.e0402176.js\",\"5dGIX\",\"animation-illustration.e7d4fb5a.js\",\"a3B2V\",\"jira-switcher.f6d0027a.js\",\"9B1r0\",\"confluence-switcher.e2af468f.js\",\"kgItH\",\"generic-switcher.19d312ae.js\",\"iHvjC\",\"PageLayout.f1f03f10.js\",\"6m2wP\",\"render.d9c836b1.js\",\"8gQKz\",\"render.12c79f16.js\",\"gopxm\",\"render.7273d928.js\",\"9N316\",\"render.f432617b.js\",\"603iI\",\"render.debb7bfd.js\",\"dVwBo\",\"render.e192e851.js\",\"ipxYo\",\"render.c53f1249.js\",\"l37ax\",\"render.3cae28bc.js\",\"ntv3W\",\"render.66ea03d1.js\",\"1b5ye\",\"render.0fed852b.js\",\"lXsOU\",\"render.458c9bb5.js\",\"8Y9rK\",\"welcome-animation-light.91126d70.js\",\"l1BtG\",\"welcome-animation-dark.09187bd2.js\",\"11Bht\",\"blue-check.f5effdaa.png\",\"2oFev\",\"teamwork_collection_header.dark.0d6ead39.png\",\"1BVx6\",\"teamwork_collection_header.light.46f39a8e.png\",\"4ZR2o\",\"fifty.abdada8e.png\",\"fBH6U\",\"fiftyThree.6ce48328.png\",\"60em6\",\"globe.dark.fbccc4d9.png\",\"5CCxM\",\"globe.light.2344933d.png\",\"8pCSP\",\"hands.dark.bd8223d6.png\",\"jtD98\",\"hands.light.add920b2.png\",\"7FV1a\",\"rocket.dark.8a5d8806.png\",\"kSDNQ\",\"rocket.light.5724cf21.png\",\"8PIke\",\"seventySix.1aa6f055.png\",\"kGn6D\",\"thirty.1bbec77d.png\",\"1N7VI\",\"sparkle.dark.3b7d2326.png\",\"2vmKM\",\"sparkle.light.3275acd0.png\",\"heZIV\",\"confirmationBackground.dark.ce573e8a.png\",\"4BM6n\",\"confirmationBackground.light.10d16729.png\",\"3mvx6\",\"warning.f5011eb7.png\",\"lOVL5\",\"app-tiles.dark.8e97838c.png\",\"cqGeb\",\"app-tiles.light.c0171e78.png\",\"fYmaw\",\"normalizeSeatBackground.dark.3ce9cef1.png\",\"26YAb\",\"normalizeSeatBackground.light.c079ea47.png\",\"3EtHp\",\"provisioning.light.12580c01.js\",\"9m8Nr\",\"provisioning.dark.548ad10c.js\",\"4E6dy\",\"icons.light.bbb50d8d.js\",\"8JoSD\",\"icons.dark.b514e288.js\",\"7Kh5o\",\"Loom_Rovo.7e012e67.png\",\"eEBx4\",\"render.766b1d07.js\",\"f7nCb\",\"render.dfdc65e6.js\",\"9xrtp\",\"render.f3fd740e.js\",\"iFcso\",\"render.2c8a5b7c.js\",\"6gEtt\",\"render.89ad81d0.js\",\"br5B5\",\"cs.77653e15.js\",\"gjHAC\",\"da.29cb31a8.js\",\"50jL1\",\"de.6ac9c578.js\",\"icT1H\",\"en-GB.6e22a219.js\",\"jHACf\",\"en-US.74c2d95c.js\",\"gxykq\",\"en-XA.93384ee1.js\",\"jwi3q\",\"en-XB.8fd7d08a.js\",\"4vq5I\",\"en-ZZ.fc86b020.js\",\"3IaOg\",\"es.bff3b1ca.js\",\"c1t91\",\"et.96209c15.js\",\"5x1Zd\",\"fi.f6d4c608.js\",\"eNry3\",\"fr.76857f57.js\",\"cmudZ\",\"hr.9eda1dd8.js\",\"qOVvt\",\"hu.ce65db05.js\",\"cLRtU\",\"it.8d47acb1.js\",\"fWDs2\",\"ja.c832628a.js\",\"isQud\",\"ko.5ab13cf1.js\",\"iX3CG\",\"nb.7e2fbe68.js\",\"5GFyb\",\"nl.1de5b36d.js\",\"fDZox\",\"pl.e8103c49.js\",\"gYq2J\",\"pt-BR.db06477b.js\",\"4MDcN\",\"ro.6b8de570.js\",\"djU0u\",\"ru.7e5f867d.js\",\"gUvh2\",\"sl.adb9638d.js\",\"kb7kZ\",\"sr-RS.3b825f92.js\",\"kGHpg\",\"sr-YR.eb30ef98.js\",\"8GEyD\",\"sr.947e8003.js\",\"gSB6X\",\"sv.aecf40aa.js\",\"9s4Da\",\"th.34906a27.js\",\"f73pl\",\"tr.c80d459d.js\",\"jmWj5\",\"uk.8f0e380b.js\",\"inGUf\",\"vi.2a03c571.js\",\"9rQBn\",\"zh-CN.da1bdc7c.js\",\"4DECc\",\"zh-TW.5274fc2e.js\",\"88qM1\",\"PageLayout.1ddabbcf.js\",\"efZH2\",\"recent-work-client.36231f88.js\",\"4KiYL\",\"image.411671ed.js\",\"5GUmv\",\"search-error-dark.43e0a164.svg\",\"14R3W\",\"search-error-light.02ef2e6f.svg\",\"5nvBH\",\"landing-dark.4ee27e71.svg\",\"kv0qb\",\"landing-light.0988f0a2.svg\",\"8yV1V\",\"no-results-dark.a00ae47b.svg\",\"3bsGr\",\"no-results-light.5ca83755.svg\",\"EfTik\",\"hoverCard.35e4dd95.js\",\"8F6ik\",\"result-provider.97b8627d.js\",\"hHoTx\",\"error-image.3040c8c6.js\",\"lUh9w\",\"async-select.82ce4d4f.js\",\"fEM7I\",\"static-select-filter.6fa97146.js\",\"bBtaF\",\"multi-select-filter.8196d2b9.js\",\"3BloW\",\"image.8b35f735.js\",\"9RypW\",\"image.7359ba77.js\",\"4alnS\",\"no-results-light.5ca83755.svg\",\"bE2Fu\",\"no-results-dark.a00ae47b.svg\",\"6kNSo\",\"autocorrection-renderer.c4457480.js\",\"eQXoP\",\"image.6d8a5de7.js\",\"yzZO6\",\"search-error-light.02ef2e6f.svg\",\"e84X7\",\"search-error-dark.43e0a164.svg\",\"6sXO4\",\"drop-down-links.16d8050a.js\",\"4Sse2\",\"image.4aa8af18.js\",\"4KkwT\",\"prequery-empty-screen-light.0988f0a2.svg\",\"eM7lm\",\"prequery-empty-screen-dark.4ee27e71.svg\",\"5kEKD\",\"upsell-modal.735392a2.js\",\"kqtzG\",\"compass-bitbucket-upsell-banner.1bbe07cf.png\",\"jjAxo\",\"smart-user-picker.1278bf1d.js\",\"8XFC9\",\"ai-answer-onboarding-banner.1fdd4b61.js\",\"kTH1d\",\"definition-popup-content.e6914a5b.js\",\"5QGog\",\"search-client.7c367017.js\",\"fiCwF\",\"search-ai.7a14fa81.js\",\"15Tws\",\"ProfileCard.0da89885.js\",\"jnkIk\",\"TeamProfileCard.5747d7b3.js\",\"8lF3J\",\"office-building.ef555956.js\",\"9pOQS\",\"team-preview-panel.f86e9358.js\",\"8hSeL\",\"arrow-up-right--editor-open.ea870a79.js\",\"hl547\",\"feedback--editor-feedback.fa1b5b06.js\",\"3OvgW\",\"definition-popup-content.953de83a.js\",\"fPDs0\",\"Rovo.e24f6f93.svg\",\"6PtxN\",\"cs.4af6da41.js\",\"8RKtn\",\"da.00cc494f.js\",\"fCIoO\",\"de.feb55cf0.js\",\"1geBW\",\"es.2b9a509c.js\",\"5WU5D\",\"et.c12c2abb.js\",\"i1Uow\",\"fi.577f953a.js\",\"3ZuKT\",\"fr.6da7024a.js\",\"5nJlY\",\"hu.3d953190.js\",\"Uq5C2\",\"it.d747a7e7.js\",\"9TzAL\",\"ja.6cac578c.js\",\"oPAjm\",\"ko.e5176471.js\",\"3fvcK\",\"nb.cf4f3e33.js\",\"iMYDs\",\"nl.0646b6ed.js\",\"jPHqC\",\"pl.7e10aa61.js\",\"3saM6\",\"pt_BR.2e845e69.js\",\"4hCdo\",\"pt_PT.3585f16f.js\",\"78gs3\",\"ru.6f4b63fe.js\",\"2XhMA\",\"sk.9b031399.js\",\"f7Egw\",\"sv.567af81d.js\",\"aiZUj\",\"tr.5656666a.js\",\"6rH3p\",\"th.f0261be3.js\",\"lS1VG\",\"uk.fe1da325.js\",\"fFbe4\",\"vi.32dd8df9.js\",\"7JTjB\",\"zh_TW.3a48b1fe.js\",\"dMjyc\",\"zh.37507780.js\",\"lb9xb\",\"smart-card.e7de77fb.js\",\"cPSQq\",\"renderer.b33be1bd.js\",\"9wbwa\",\"calendar-dark.a0ed3c18.svg\",\"edV1v\",\"calendar-light.caa4677f.svg\",\"5P10P\",\"location-dark.395fc7dc.svg\",\"1jWRt\",\"location-light.9d9cfd0a.svg\",\"bWcRJ\",\"file.27d59cf0.js\",\"iDB1L\",\"pen.ff9dabea.js\",\"lvdR8\",\"department.20e9a61b.js\",\"dXz7U\",\"cs.13143ef7.js\",\"gGEZv\",\"da.0f323710.js\",\"d3blt\",\"de.a8a0e118.js\",\"59Z93\",\"en_GB.45558e3e.js\",\"kotjW\",\"en_ZZ.93987f9f.js\",\"kK6se\",\"es.c83f0016.js\",\"5xf60\",\"et.7581eb28.js\",\"9VEIz\",\"fi.5446432f.js\",\"cjdHS\",\"fr.8614e9f1.js\",\"Whd6n\",\"hu.8dd60ee5.js\",\"jkUKZ\",\"is.a0ebfb14.js\",\"9LPlo\",\"it.4a7309ea.js\",\"bCZbu\",\"ja.f1564c2a.js\",\"jUfGx\",\"ko.e1093c29.js\",\"8yxgV\",\"nb.2c76f737.js\",\"dBE2i\",\"nl.0f43d0c2.js\",\"6FNZU\",\"pl.04b05a91.js\",\"ilWcC\",\"pt_BR.6dc6b536.js\",\"edU6Z\",\"pt_PT.94fccdb2.js\",\"atNxX\",\"ro.e8b3e3a3.js\",\"gpgvY\",\"ru.2e54f96b.js\",\"3IA7L\",\"sk.9ec26891.js\",\"hpq4P\",\"sv.ad997a57.js\",\"8WMbP\",\"th.6175914e.js\",\"kffHA\",\"tr.bb041aad.js\",\"2zh8u\",\"uk.6e478a67.js\",\"9YoTA\",\"vi.15a86188.js\",\"a9qyt\",\"zh.219f4ec1.js\",\"04egH\",\"zh_TW.feba8bdb.js\",\"1Ojgx\",\"ai-answer-prompt.f9b04a92.js\",\"eVnxm\",\"trello-body.cf948b9e.js\",\"2exA8\",\"trello-popper.d0100eb6.js\",\"3Kg3S\",\"CreateComponent.a8561191.js\",\"9y1Aa\",\"WhiteboardGAModalManager.cc01770c.js\",\"dIuWY\",\"GAOnboardingAnnouncement.98a7a653.gif\",\"b8oHe\",\"EngagementInlineDialogWrapper.2fd1cb33.js\",\"a6eof\",\"PageLayout.e679080e.js\",\"jfTrX\",\"AppNavigation.3850a2d1.js\",\"hesl9\",\"RecentPages.8c8905ee.js\",\"8q7U9\",\"Collaboration.a011f6bd.svg\",\"eJwDQ\",\"SearchError.ab7cb722.svg\",\"lPQcc\",\"team-preview-panel.70192f19.js\",\"6JvQz\",\"PeopleItemWrapper.a9b1d783.js\",\"6SYnx\",\"teamCreateDialog.f7b23588.js\",\"40B2u\",\"MenuContent.3e2f795b.js\",\"bZtF0\",\"th.078cde1d.js\",\"9pBxJ\",\"uk.bd28f54b.js\",\"bM16t\",\"vi.1760e489.js\",\"2ZapG\",\"AppsContent.8183ccda.js\",\"emP1M\",\"blocks.348a3d50.svg\",\"1Zku8\",\"DiscoverSection.f651e273.js\",\"bVqnE\",\"CustomHomepageItem.496e1a0f.js\",\"F2Q4u\",\"AppSwitcherComponentWrapper.6c02dc7d.js\",\"5GXmr\",\"AppSwitcherContent.87e6efd8.js\",\"aOHmb\",\"app-switcher.6d284817.js\",\"df12q\",\"NotificationsComponent.dae4aa0d.js\",\"lpfAf\",\"notification.cbda05c9.js\",\"iW7i1\",\"NotesComponent.7a5b5f80.js\",\"heZTL\",\"SettingsComponent.cceedf99.js\",\"6YgN9\",\"MenuComponent.938672db.js\",\"eXOVv\",\"HelpComponent.1d9e1d96.js\",\"01qRE\",\"SearchComponent.e05a4202.js\",\"61fF8\",\"clock--emoji-frequent.0a3f8620.js\",\"cMlHc\",\"24.6db1f7ff.js\",\"eErVv\",\"cards-extension.28632dca.js\",\"dD4ld\",\"filter.cbc0c993.js\",\"eHw9Y\",\"ProfileComponent.c40f6ecc.js\",\"9IyPY\",\"ProfileMenu.9ecafaaa.js\",\"65NKm\",\"log-in--sign-in.2e28e5a3.js\",\"9PQXU\",\"AppNavigation.b333bbaa.js\",\"jmmCO\",\"RightSidebar.f10d233f.js\",\"jLbdY\",\"PageLayout.1ae4d255.js\",\"lgm1i\",\"StandaloneRestrictedPageOrSpace.6c25f157.js\",\"kUiwW\",\"RestrictedPage.3d0bf3e2.js\",\"L0tFv\",\"RestrictedContentIcon-Light.e0fef1fb.svg\",\"55AxV\",\"RestrictedContentIcon-Dark.bc90ae31.svg\",\"2OcM6\",\"RestrictedSpace.127d2943.js\",\"7DDw1\",\"ConfluenceLogo.37570e84.svg\",\"k0WnS\",\"ExternalPageNotFoundV2.acc15a40.js\",\"4J5D7\",\"not-found-v2.ab9d1086.svg\",\"lwfE5\",\"ArchiveSpacePortal.9719f35c.js\",\"j06N4\",\"ArchiveSpacePanel.5b30bb5c.js\",\"d7sp9\",\"DeleteSpacePortal.8d10c773.js\",\"c8zt5\",\"ImportRbacWarningPortal.08677989.js\",\"jzhuW\",\"ImportRbacWarning.6d2c539d.js\",\"ei0Jg\",\"SpaceSettingsForgeExtensionPortal.236b7838.js\",\"hhf8b\",\"SpaceTrashPortal.f1e77515.js\",\"an2zh\",\"SiteSettingsHelpPanelLink.48fe27c8.js\",\"82QsP\",\"InProductHelpButton.7a0d37dc.js\",\"gJRFC\",\"BackupManagerButton.576a1571.js\",\"3rir4\",\"dashboard-spa-container-jquery3.97aebd3d.js\",\"CoGBw\",\"dashboard-spa-container-jquery3.runtime.d75fe574.js\",\"eiF7i\",\"stable_vendors.251bfc4c.js\"]"));
 }, ["7EorR","3rir4","CoGBw","eiF7i","aZinD","hhss7","ffEVr","Wowvf","kjZZD","6wr18"]);
$parcel$global.rwr("3pblT", () => { 
var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $5QpZa = parcelRequire("5QpZa");


var $hp2SH = parcelRequire("hp2SH");


var $iC5L0 = parcelRequire("iC5L0");


var $aXEzU = parcelRequire("aXEzU");





var $3WLLD = parcelRequire("3WLLD");


var $bj5fB = parcelRequire("bj5fB");





var $7J5Uc = parcelRequire("7J5Uc");

const $14d55bbfca2abbc5$export$7a88623f52f1b79 = (initialTheme)=>{
    const [{ isInitialized: isInitialized }, { initializeTheme: initializeTheme }] = (0, $7J5Uc.useThemingState)();
    (0, $42omo.useEffect)(()=>{
        initializeTheme(initialTheme);
    // Only execute upon initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return isInitialized;
};


const $e6baa9171970034d$export$11eb671888ed6e7d = ({ children: children })=>{
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const initialTheme = isMobileApp ? (0, $3WLLD.mobileAppTheme) : undefined;
    const isInitialized = (0, $14d55bbfca2abbc5$export$7a88623f52f1b79)(initialTheme);
    if (!isInitialized) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};



var $7zgzO = parcelRequire("7zgzO");


var $bLJr5 = parcelRequire("bLJr5");


var $9j59h = parcelRequire("9j59h");


var $xwvlW = parcelRequire("xwvlW");


var $2DVQX = parcelRequire("2DVQX");


var $7LuKf = parcelRequire("7LuKf");





var $6g1oe = parcelRequire("6g1oe");


var $4xcIM = parcelRequire("4xcIM");


var $2FNjD = parcelRequire("2FNjD");


var $ge2sX = parcelRequire("ge2sX");

var $f7i8j = parcelRequire("f7i8j");


var $cryCi = parcelRequire("cryCi");


var $dBmJE = parcelRequire("dBmJE");








var $kFqI2 = parcelRequire("kFqI2");


var $T1bCI = parcelRequire("T1bCI");


var $lonEO = parcelRequire("lonEO");


var $iJELi = parcelRequire("iJELi");


var $d5ap9 = parcelRequire("d5ap9");


var $hmRc4 = parcelRequire("hmRc4");


var $fcF01 = parcelRequire("fcF01");


var $iJiK8 = parcelRequire("iJiK8");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $25MM7 = parcelRequire("25MM7");








var $64KID = parcelRequire("64KID");


var $dEBDF = parcelRequire("dEBDF");


var $8n9tL = parcelRequire("8n9tL");


var $1ytiN = parcelRequire("1ytiN");


var $a5txT = parcelRequire("a5txT");


var $97W74 = parcelRequire("97W74");

class $7db816b9e13721ff$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    getChildContext() {
        const { context: context } = this.props;
        const noop = ()=>{};
        return {
            insertCss: context.insertCss || noop
        };
    }
    render() {
        const { store: store } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Provider), {
            inject: [
                (0, $a5txT.getStandalonePageTreeStateUpdater)()
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lonEO.GraphqlProvider), {
            client: (0, $hp2SH.getApolloClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kFqI2.Provider), {
            store: store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1ytiN.SPAViewContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
            value: (0, $fGzMp.getExperienceTracker)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bLJr5.I18nProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5ap9.ConfluenceAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dEBDF.NavdexListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $97W74.EngagementProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dBmJE.ConnectedRouter), {
            history: this.browserHistory,
            context: (0, $kFqI2.ReactReduxContext)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fcF01.UpFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $25MM7.Flags), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJELi.ConnectSupport), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8n9tL.RouteManager), {
            namedRoutes: (0, $64KID.namedRoutes)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJiK8.Dialogs), null), this.props.children))))))))))));
    }
    constructor(...args){
        super(...args);
        this.browserHistory = (0, $hmRc4.getBrowserHistory)();
    }
}
$7db816b9e13721ff$export$2e2bcd8739ae039.propTypes = {
    /**
   * Global store
   */ store: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    /**
   * Context including the css handler (It has different versions for client and server rendering)
   */ context: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).shape({
        insertCss: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
    }),
    /**
   * Children Component
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).any,
    /**
   * Indicates if the component is rendered as Root
   */ renderAsRoot: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$7db816b9e13721ff$export$2e2bcd8739ae039.childContextTypes = {
    /**
   * Handler for css injection in components.
   */ insertCss: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};



var $3Tw8v = parcelRequire("3Tw8v");


var $9F7Qb = parcelRequire("9F7Qb");

const $d4f95b5cede9219f$var$store = (0, $3Tw8v.default)({
    isServerRenderedPage: true
});
(0, $9F7Qb.subscribe)($d4f95b5cede9219f$var$store);
const $d4f95b5cede9219f$var$context = {
    insertCss: (styles)=>styles._insertCss()
};
/**
 * Method for rendering React/Redux component
 * Usage:
 * import renderComponent from './renderComponentIntoDOM';
 * renderComponent(<YourComponent />, 'your-component-section-id');
 * OR renderComponent(<YourComponent />, DOMComponent);
 *
 * @param children
 * @param container DOM node or id string
 */ const $d4f95b5cede9219f$var$renderComponentIntoDOM = (children, container, renderAsRoot = false)=>{
    if (typeof container === 'string') container = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.getElementById(container);
    const Component = ({ sessionData: sessionData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
            value: sessionData
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cryCi.Provider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7db816b9e13721ff$export$2e2bcd8739ae039), {
            store: $d4f95b5cede9219f$var$store,
            context: $d4f95b5cede9219f$var$context,
            renderAsRoot: renderAsRoot
        }, children)));
    Component.propTypes = {
        sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired
    };
    (0, $ge2sX.getSessionData)().then((sessionData)=>{
        const concurrentComponentWrapper = (0, $2FNjD.createRoot)(container);
        concurrentComponentWrapper.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            sessionData: sessionData
        }));
    });
};
var $d4f95b5cede9219f$export$2e2bcd8739ae039 = $d4f95b5cede9219f$var$renderComponentIntoDOM;



var $7RVQB = parcelRequire("7RVQB");


var $feRZU = parcelRequire("feRZU");




/**
 * These helper functions should be used to minimize the impact the standalone sidebar causes to the ui (jump, flip, flash, jank);
 */ const $8bee1fe38b9eef04$var$mainSectionsSelectors = [
    '#main',
    '#admin-content',
    '#custom-content-container',
    '.ap-servlet-placeholder'
];
const $8bee1fe38b9eef04$export$ed04e7f6ba662aee = ()=>{
    const head = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.head || (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.querySelector('head');
    const style = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.createElement('style');
    const css = `${$8bee1fe38b9eef04$var$mainSectionsSelectors.join(',')} { opacity: 0 };`;
    style.type = 'text/css';
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.createTextNode(css));
    if (head) head.appendChild(style);
};
const $8bee1fe38b9eef04$export$4011f4c5a8044281 = (runs = 0)=>{
    const mainContainers = $8bee1fe38b9eef04$var$mainSectionsSelectors.map((selector)=>(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.querySelector(selector)).filter((ele)=>ele !== null);
    if (mainContainers.length) mainContainers.forEach((container)=>{
        if (container) {
            container.style.transition = 'opacity .15s ease-in';
            container.style.opacity = '1';
        }
    });
    else // accounting for any race condition that could delay the parsing of the content
    if (runs < 5) {
        console.warn('Legacy pages: trying to fix jank behaviour on legacy pages but content container is not found yet');
        setTimeout(()=>$8bee1fe38b9eef04$export$4011f4c5a8044281(runs + 1), 100);
    } else console.error('Legacy pages: content container was not found');
};






var $iyEDi = parcelRequire("iyEDi");


var $gnnzK = parcelRequire("gnnzK");


var $1NBp8 = parcelRequire("1NBp8");

/* StandaloneConfluenceNavigation.js generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $eXODy = parcelRequire("eXODy");


var $iV00x = parcelRequire("iV00x");


var $3pfAb = parcelRequire("3pfAb");


var $NAPtM = parcelRequire("NAPtM");





var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $bQm3c = parcelRequire("bQm3c");











var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $30qWc = parcelRequire("30qWc");





var $gqqjz = parcelRequire("gqqjz");








var $b1HmN = parcelRequire("b1HmN");


var $eSUdr = parcelRequire("eSUdr");

const $13bb14eac5ea00fc$export$bae28e68d0aa638c = (0, $eSUdr.default)`mutation ClearRestrictionsForFreeMutation($contentId:ID!){clearRestrictionsForFree(contentId:$contentId){restrictionsHash}}`;


const $e5314625536bb69f$export$8a37b2ec23f0faea = 'confluence-change-edition-remove-restrictions-button';
const $e5314625536bb69f$export$9f92e67dea336ca7 = 'confluence-change-edition-notification-dialog';
const $e5314625536bb69f$var$i18n = (0, $cgtv4.defineMessages)({
    removeRestrictionButton: {
        id: "change-edition.notification.dialog.general.button.remove-restrictions",
        defaultMessage: "Remove restrictions"
    },
    removeRestrictionTitle: {
        id: "change-edition.notification.dialog.general.title.remove-restrictions-2",
        defaultMessage: "Remove restrictions?"
    },
    removeRestrictionTextSpaceLevel: {
        id: "change-edition.notification.dialog.space.text.remove-restrictions",
        defaultMessage: "You\u2019re on the free plan, so you can only <b>remove all restrictions</b> from <b>{contentTitle}</b>. <b>This can\u2019t be undone.</b> You won\u2019t be able to reset the restrictions later."
    },
    removeRestrictionConfirmationSuccessTitle: {
        id: "change-edition.notification.dialog.confirmation.success.title",
        defaultMessage: "Restrictions removed"
    },
    removeRestrictionConfirmationSuccessDesc: {
        id: "change-edition.notification.dialog.confirmation.success.desc",
        defaultMessage: "Anyone who\u2019s logged in can now view and edit {contentTitle}."
    },
    removeRestrictionConfirmationFailedTitle: {
        id: "change-edition.notification.dialog.confirmation.failed.title",
        defaultMessage: "Page restrictions not removed"
    },
    removeRestrictionConfirmationFailedDesc: {
        id: "change-edition.notification.dialog.confirmation.failed.desc",
        defaultMessage: "We couldn\u2019t remove restrictions from {contentTitle}. Try again."
    }
});
const $e5314625536bb69f$var$DEFAULT_COMPONENT_STATE = {
    isNotificationOpen: false,
    isMutationInProcess: false,
    contentId: null,
    contentTitle: null
};
//TODO: remove dep on shared i18n.
const $e5314625536bb69f$var$changeEditionPageRestrictionsLegacyCoordinatorI18n = (0, $cgtv4.defineMessages)({
    // Notification Dialog --------------------
    cancelButton: {
        id: "change-edition.general.button.cancel",
        defaultMessage: "Cancel"
    }
});
class $e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent extends (0, $42omo.PureComponent) {
    componentDidMount() {
        Array.prototype.forEach.call(this.allRemoveRestrictionsElements, (el)=>{
            el.addEventListener('click', this.openNotificationDialog);
        });
    }
    componentWillUnmount() {
        Array.prototype.forEach.call(this.allRemoveRestrictionsElements, (el)=>{
            el.removeEventListener('click', this.openNotificationDialog);
        });
    }
    render() {
        const { intl: intl } = this.props;
        const { isNotificationOpen: isNotificationOpen, isMutationInProcess: isMutationInProcess, contentTitle: contentTitle, contentId: contentId } = this.state;
        if (!this.placeholderEl) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>{
            const route = matchRoute(location.pathname);
            // Skip rendering for other then "Space Setting / Restricted Page" page
            if (!route || route.name != (0, $1NBp8.SPACE_RESTRICTED_PAGES).name) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $30qWc.MutationInterop), {
                    mutation: (0, $13bb14eac5ea00fc$export$bae28e68d0aa638c),
                    variables: {
                        contentId: contentId
                    },
                    onCompleted: this.handleMutationComplete(flags),
                    onError: this.handleMutationError(flags)
                }, (clearRestrictionsForFreeMutation)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1HmN.LoadableChangeEditionNotificationDialog), {
                        isOpen: isNotificationOpen,
                        isProcessing: isMutationInProcess,
                        cancelAction: {
                            text: intl.formatMessage($e5314625536bb69f$var$changeEditionPageRestrictionsLegacyCoordinatorI18n.cancelButton),
                            onClick: this.closeNotificationDialog
                        },
                        applyAction: {
                            text: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionButton),
                            onClick: this.applyChanges(clearRestrictionsForFreeMutation)
                        },
                        heading: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionTitle),
                        source: "individualSpaceRestrictedPages",
                        grandfathered: true
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                        ...$e5314625536bb69f$var$i18n.removeRestrictionTextSpaceLevel,
                        values: {
                            contentTitle: contentTitle,
                            b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
                        }
                    })))), this.placeholderEl);
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            ...$e5314625536bb69f$var$DEFAULT_COMPONENT_STATE
        };
        this.allRemoveRestrictionsElements = window.document.getElementsByClassName($e5314625536bb69f$export$8a37b2ec23f0faea) || [];
        this.placeholderEl = window.document.getElementById($e5314625536bb69f$export$9f92e67dea336ca7);
        this.openNotificationDialog = (event)=>{
            this.setState({
                isNotificationOpen: true,
                contentId: event.target.getAttribute('data-page-id'),
                contentTitle: event.target.getAttribute('data-page-title')
            });
        };
        this.closeNotificationDialog = ()=>{
            this.setState($e5314625536bb69f$var$DEFAULT_COMPONENT_STATE);
        };
        this.applyChanges = (mutationFunction)=>()=>{
                this.setState({
                    isMutationInProcess: true
                });
                mutationFunction();
            };
        this.handleMutationComplete = (flags)=>()=>{
                const { intl: intl } = this.props;
                const { contentTitle: contentTitle } = this.state;
                flags.showSuccessFlag({
                    title: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationSuccessTitle),
                    description: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationSuccessDesc, {
                        contentTitle: contentTitle
                    })
                });
                this.closeNotificationDialog();
                window.setTimeout(()=>{
                    // refresh the page to see the changes
                    window.location.reload();
                }, 500);
            };
        this.handleMutationError = (flags)=>()=>{
                const { intl: intl } = this.props;
                const { contentTitle: contentTitle } = this.state;
                flags.showErrorFlag({
                    title: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationFailedTitle),
                    description: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationFailedDesc, {
                        contentTitle: contentTitle
                    })
                });
                this.closeNotificationDialog();
            };
    }
}
$e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent.propTypes = {
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
};
const $e5314625536bb69f$export$5b44234181f42094 = (0, $gmMgo.default)($e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent);




















var $8C5kA = parcelRequire("8C5kA");





var $4WmbV = parcelRequire("4WmbV");

const $4c2daaa3bc0c282d$var$i18n = (0, $cgtv4.defineMessages)({
    siteAdminAuditLogsTitle: {
        id: "change-edition.section.message.site-admin.audit-logs.title",
        defaultMessage: "Upgrade for Audit logs"
    },
    nonSiteAdminAuditLogsTitle: {
        id: "change-edition.section.message.non-site-admin.audit-logs.title",
        defaultMessage: "Audit logs are only available on paid plans"
    },
    siteAdminAuditLogsBody: {
        id: "change-edition.section.message.site-admin-audit-logs.body",
        defaultMessage: "You\u2019re on the free plan, so you can\u2019t view and track changes made across your site in the audit logs. To access the audit logs, upgrade your plan."
    },
    nonSiteAdminAuditLogsBody: {
        id: "change-edition.section.message.non-site-admin-audit-logs.body",
        defaultMessage: "You\u2019re on the free plan, so you can\u2019t view and track changes made across your site in the audit logs."
    }
});
const $4c2daaa3bc0c282d$export$cb2ba78fe55aff74 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const title = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsTitle : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsTitle;
    const body = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsBody : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsBody;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        title: formatMessage(title),
        body: formatMessage(body),
        source: "auditLogs"
    });
};














var $f7Bnv = parcelRequire("f7Bnv");




const $ee74963fbde2c4ed$var$i18n = (0, $cgtv4.defineMessages)({
    siteAdminContentRestrictionsTitle: {
        id: "change-edition.section.message.site-admin.content-restrictions.title",
        defaultMessage: "Upgrade for content-level restrictions"
    },
    nonSiteAdminContentRestrictionsTitle: {
        id: "change-edition.section.message.non-site-admin.content-restrictions.title",
        defaultMessage: "Content-level restrictions are only available on paid plans"
    },
    spaceRestrictedPagesText: {
        id: "change-edition.section.message.space-restricted-pages.text",
        defaultMessage: "You\u2019re on the free plan, so you can only remove all restrictions from content by clicking the lock icon below. To set restrictions, upgrade your plan."
    },
    nonSiteAdminGrandfatheredRestrictedPagesBody: {
        id: "change-edition.section.message.non-admin.grandfathered.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so you can only remove all restrictions from content by clicking the lock icon below."
    },
    siteAdminRestrictedPagesBody: {
        id: "change-edition.section.message.site-admin.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so anyone who\u2019s logged in can view and edit everything. To set restrictions, upgrade your plan."
    },
    nonSiteAdminRestrictedPagesBody: {
        id: "change-edition.section.message.non-admin.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so anyone who\u2019s logged in can view and edit everything."
    }
});
function $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered) {
    if (grandfathered) {
        if (isSiteAdmin) return $ee74963fbde2c4ed$var$i18n.spaceRestrictedPagesText;
        else return $ee74963fbde2c4ed$var$i18n.nonSiteAdminGrandfatheredRestrictedPagesBody;
    } else {
        if (isSiteAdmin) return $ee74963fbde2c4ed$var$i18n.siteAdminRestrictedPagesBody;
        else return $ee74963fbde2c4ed$var$i18n.nonSiteAdminRestrictedPagesBody;
    }
}
const $ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent = ({ grandfathered: grandfathered, isSiteAdmin: isSiteAdmin })=>{
    const intl = (0, $8C5kA.default)();
    const bodyText = $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered);
    const title = isSiteAdmin ? $ee74963fbde2c4ed$var$i18n.siteAdminContentRestrictionsTitle : $ee74963fbde2c4ed$var$i18n.nonSiteAdminContentRestrictionsTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        title: intl.formatMessage(title),
        body: intl.formatMessage(bodyText),
        source: "individualSpaceRestrictedPages"
    });
};
$ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent.propTypes = {
    grandfathered: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired,
    isSiteAdmin: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};
const $ee74963fbde2c4ed$export$51350d82d36f7e43 = (0, $f7Bnv.withIsSiteAdmin)($ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent);


const $63cbc74b40cb8d33$export$4a53029580aac53e = 'confluence-change-edition-section-message';
class $63cbc74b40cb8d33$export$b9f1eac8c818cdb0 extends (0, $42omo.Component) {
    isSectionMessageNeeded(routeName) {
        return routeName && Boolean(this.ROUTE_NAME2COMPONENT[routeName.name]);
    }
    getComponentParams(routeName) {
        if (routeName === (0, $1NBp8.SPACE_RESTRICTED_PAGES).name) return {
            grandfathered: this.el.getAttribute('data-grandfathered') === 'true'
        };
        return {};
    }
    render() {
        if (!this.el) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>{
            const routeName = matchRoute(location.pathname + location.search);
            if (!this.isSectionMessageNeeded(routeName)) return null;
            const ChangEditionComponent = this.ROUTE_NAME2COMPONENT[routeName.name];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ChangEditionComponent, this.getComponentParams(routeName.name)), this.el);
        });
    }
    constructor(...args){
        super(...args);
        this.el = window.document.getElementById($63cbc74b40cb8d33$export$4a53029580aac53e);
        this.ROUTE_NAME2COMPONENT = {
            [(0, $1NBp8.SPACE_RESTRICTED_PAGES).name]: (0, $ee74963fbde2c4ed$export$51350d82d36f7e43),
            [(0, $1NBp8.ADMIN_AUDIT_LOG).name]: (0, $4c2daaa3bc0c282d$export$cb2ba78fe55aff74)
        };
    }
}


const $f60f9bb0af41c642$export$ddc928ad192d2b94 = ()=>(0, $bQm3c.useSessionData)().edition === 'FREE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63cbc74b40cb8d33$export$b9f1eac8c818cdb0), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5314625536bb69f$export$5b44234181f42094), null))) : null;






var $4PPzL = parcelRequire("4PPzL");


var $04e9M = parcelRequire("04e9M");





var $1dnxO = parcelRequire("1dnxO");


var $aeSHO = parcelRequire("aeSHO");


var $iJ8K8 = parcelRequire("iJ8K8");


var $4l6Wo = parcelRequire("4l6Wo");


var $hDG7z = parcelRequire("hDG7z");


var $eWwvy = parcelRequire("eWwvy");


var $39rFu = parcelRequire("39rFu");





var $cBuRD = parcelRequire("cBuRD");





var $eIKcA = parcelRequire("eIKcA");





var $ezLwY = parcelRequire("ezLwY");

/**
 * shortcutContext('global') or shortcutContext(['global', 'viewcontent'])
 * @param context
 * @returns {Function}
 */ function $089e60b6c1a73ffc$var$shortcutContext(context) {
    return (BaseComponent)=>{
        class ShortcutContextComponent extends (0, $42omo.Component) {
            componentDidMount() {
                (0, $ezLwY.enableContext)(context);
            }
            componentWillUnmount() {
                (0, $ezLwY.disableContext)(context);
            }
            render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BaseComponent, this.props);
            }
        }
        ShortcutContextComponent.displayName = `ShortcutContextComponent(${BaseComponent.displayName || BaseComponent.name})`;
        return ShortcutContextComponent;
    };
}
var $089e60b6c1a73ffc$export$2e2bcd8739ae039 = $089e60b6c1a73ffc$var$shortcutContext;



var $jmjWc = parcelRequire("jmjWc");


const $f05a18473f890654$export$ffff49ea750347f8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3CTAv",
    name: "StandaloneRestrictedPageOrSpace",
    loader: async ()=>(await (parcelRequire("fmuCC"))).StandaloneRestrictedPageOrSpace
});



var $jwv1p = parcelRequire("jwv1p");


var $arkw6 = parcelRequire("arkw6");


var $3j0Cc = parcelRequire("3j0Cc");


var $4QflW = parcelRequire("4QflW");





var $ba9cbe60fdf9141e$exports = {};

var $bCMS0 = parcelRequire("bCMS0");


var $daAKm = parcelRequire("daAKm");


var $ehlgT = parcelRequire("ehlgT");


var $fPVB6 = parcelRequire("fPVB6");

/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */ function $ba9cbe60fdf9141e$var$endsWith(string, target, position) {
    string = $fPVB6(string);
    target = $daAKm(target);
    var length = string.length;
    position = position === undefined ? length : $bCMS0($ehlgT(position), 0, length);
    var end = position;
    position -= target.length;
    return position >= 0 && string.slice(position, end) == target;
}
$ba9cbe60fdf9141e$exports = $ba9cbe60fdf9141e$var$endsWith;



var $jzEl8 = parcelRequire("jzEl8");

const $9117dce6b863f439$var$LINKS_TO_BE_REMOVED = [
    '#action-page-permissions-link'
];
const $9117dce6b863f439$var$LINKS_TO_BE_REMOVED_ON_PAGE_INFORMATION = [
    '#page-favourite',
    '#action-menu-link'
];
const $9117dce6b863f439$var$replacedPlaceholder = {
    elementName: 'span',
    attributes: {
        style: `display: none`
    }
};
function $9117dce6b863f439$export$9e2c81a475b5d1b8() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jzEl8.LegacyDOMBridge), {
        selectors: $9117dce6b863f439$var$LINKS_TO_BE_REMOVED,
        attempts: 100,
        retryDelay: 500,
        portalNode: null,
        replacePlaceholderWith: $9117dce6b863f439$var$replacedPlaceholder
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ba9cbe60fdf9141e$exports)))(window.location.pathname, '/pages/viewinfo.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jzEl8.LegacyDOMBridge), {
        selectors: $9117dce6b863f439$var$LINKS_TO_BE_REMOVED_ON_PAGE_INFORMATION,
        attempts: 100,
        retryDelay: 500,
        replacePlaceholderWith: $9117dce6b863f439$var$replacedPlaceholder,
        portalNode: null
    }));
}














var $inPa6 = parcelRequire("inPa6");








const $b82761c2a95901d5$export$18a8a22069631f81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kdP2C",
    loader: async ()=>(await (parcelRequire("7CN7P"))).ArchiveSpacePortal,
    name: 'ArchiveSpacePortal'
});






const $e87d969ba20a20a0$export$854f67824ef9311 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "P3ji1",
    loader: async ()=>(await (parcelRequire("3Husr"))).DeleteSpacePortal,
    name: 'DeleteSpacePortal'
});






const $fed5c5e01455732b$export$55dbecb078810469 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "gQ40M",
    name: "ImportRbacWarningPortal",
    loader: async ()=>(await (parcelRequire("7WvNl"))).ImportRbacWarningPortal
});






const $a6c6b76f924ecb80$export$b4b583c595949768 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BlJ6r",
    name: "LazySpaceSettingsForgeExtensionPortal",
    loader: async ()=>(await (parcelRequire("9GEwo"))).SpaceSettingsForgeExtensionPortal
});
$a6c6b76f924ecb80$export$b4b583c595949768.displayName = 'LazySpaceSettingsForgeExtensionPortal';



var $7QM6o = parcelRequire("7QM6o");


var $feuG2 = parcelRequire("feuG2");





const $b270d87888ab1caf$export$cca256d7c562dc07 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "mTzRP",
    loader: async ()=>(await (parcelRequire("7nmkU"))).SpaceTrashPortal,
    name: 'SpaceTrashPortal'
});






const $d2b3f21ec8a84bb2$export$2c12a08ca2f15d0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wu877",
    name: "SiteSettingsHelpPanelLink",
    loader: async ()=>(await (parcelRequire("ax8Zf"))).SiteSettingsHelpPanelLink
});






const $406f60e313bf3a3f$export$b52880da76836cd4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "h3QZB",
    name: "BackupManagerButton",
    loader: async ()=>(await (parcelRequire("d1Pi6"))).BackupManagerButton
});



var $14QAi = parcelRequire("14QAi");


var $ep3mz = parcelRequire("ep3mz");

const $76c1a3880217c32d$var$i18n = (0, $cgtv4.defineMessages)({
    importingTemplates: {
        id: "standalone-navigation.importing.templates",
        defaultMessage: "More about importing templates"
    }
});
const $76c1a3880217c32d$export$fc287ab47b11c4ec = ({ spaceKey: spaceKey, isSpaceSettingsScreen: isSpaceSettingsScreen })=>{
    const { location: { pathname: pathname } } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    (0, $42omo.useEffect)(()=>{
        const { section: section, screen: screen } = (0, $14QAi.getRouteData)(pathname);
        // We only want analytics for IPH specific routes for now
        if (screen !== 'notTracked') createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: screen,
                attributes: {
                    section: section
                }
            }
        }).fire();
    }, [
        pathname,
        createAnalyticsEvent,
        spaceId
    ]);
    return pathname && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, isSpaceSettingsScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ep3mz.PageStateContainer), {
        spaceKey: spaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $feuG2.SpaceSettingsNavigationV2Portal), {
        spaceKey: spaceKey
    })) : null, pathname.includes('/spaces/archivespace.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b82761c2a95901d5$export$18a8a22069631f81), {
        spaceKey: spaceKey,
        pathname: pathname
    }), pathname.includes('/spaces/removespace.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e87d969ba20a20a0$export$854f67824ef9311), {
        spaceKey: spaceKey,
        pathname: pathname
    }), pathname.includes('/pages/viewtrash.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b270d87888ab1caf$export$cca256d7c562dc07), {
        spaceKey: spaceKey
    }), pathname.includes('/templatePackage/configurePlugin.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d2b3f21ec8a84bb2$export$2c12a08ca2f15d0e), {
        articleId: "7p0QTJJI0VkoU49M4GzKH2",
        articleTopic: "admin-import-templates",
        portalTargetId: "site-settings-import",
        buttonContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $76c1a3880217c32d$var$i18n.importingTemplates),
        pathname: pathname,
        routeGroup: "site-settings",
        routeName: "undefined"
    }), pathname.includes('/plugins/servlet/ondemandbackupmanager') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $406f60e313bf3a3f$export$b52880da76836cd4), {
        pathname: pathname
    }), pathname.includes('/import/importconfluencesite.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fed5c5e01455732b$export$55dbecb078810469), {
        spaceKey: spaceKey,
        pathname: pathname
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6c6b76f924ecb80$export$b4b583c595949768), {
        spaceKey: spaceKey
    }));
};
// needed for react-proptypes warning
$76c1a3880217c32d$export$fc287ab47b11c4ec.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    isSpaceSettingsScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};


var $7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation;
function $7c0ba11073bcb5f1$var$_defineProperty(e, r, t) {
    return (r = $7c0ba11073bcb5f1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7c0ba11073bcb5f1$var$_toPropertyKey(t) {
    var i = $7c0ba11073bcb5f1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7c0ba11073bcb5f1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $7c0ba11073bcb5f1$var$TopNavSpacer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1ule _1bsb1osq _4t3iymf6",
            __cmplp.className
        ])
    });
});
var $7c0ba11073bcb5f1$export$2e2bcd8739ae039 = (0, $089e60b6c1a73ffc$export$2e2bcd8739ae039)('global')(($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation = class StandaloneConfluenceNavigation extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { isAdminScreen: isAdminScreen } = this.props; // if admin screen, show content as we mount
        if (isAdminScreen) (0, $8bee1fe38b9eef04$export$4011f4c5a8044281)();
        else setTimeout((0, $8bee1fe38b9eef04$export$4011f4c5a8044281), 300);
        (0, $ge2sX.getSessionData)();
    }
    render() {
        const { isAdminScreen: isAdminScreen, isSpaceSettingsScreen: isSpaceSettingsScreen, isSpaceScreen: isSpaceScreen, route: route, spaceKey: spaceKey } = this.props;
        let navView;
        if ((0, $1dnxO.getIsNav4Enabled)() && isSpaceSettingsScreen) navView = (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID);
        else if (isSpaceSettingsScreen || isSpaceScreen) navView = (0, $4l6Wo.CONTAINER_HOME_ID);
        else if (isAdminScreen) navView = (0, $4l6Wo.ADMIN_HOME_ID);
        else if (route?.name !== (0, $1NBp8.EXTERNAL_SHARE).name) // XXX EXTERNAL_SHARE does not have the typical navigation.
        navView = (0, $4l6Wo.PRODUCT_HOME_ID);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f05a18473f890654$export$ffff49ea750347f8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $76c1a3880217c32d$export$fc287ab47b11c4ec), {
            spaceKey: spaceKey,
            isSpaceSettingsScreen: isSpaceSettingsScreen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aeSHO.CopySpacePermissionsForLegacyNewSpace), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pfAb.default), {
            client: (0, $04e9M.getAnalyticsWebClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39rFu.EditPageLoadingContextProvider), {
            nativeEditorComponentsPreloader: (0, $eXODy.nativeEditorComponentsPreloader),
            livePageComponentsPreloader: (0, $jwv1p.preloadLivePagesComponents)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iV00x.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ8K8.Screen), {
            screenEvent: {
                name: 'serverRenderedScreen',
                attributes: {
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: (0, $iJ8K8.SPACE_OVERVIEW)
            }
        }, navView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hDG7z.PageLayout), {
            view: navView,
            isSpaceSettingsScreen: isSpaceSettingsScreen,
            standalone: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $NAPtM.CreateDialogContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arkw6.LazyCreateDialogQueryRenderer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3j0Cc.LazyCreateDialogBlueprintWizardRenderer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4QflW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eIKcA.default), null), isSpaceSettingsScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eWwvy.EditSpaceLogo), {
            spaceKey: spaceKey
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9117dce6b863f439$export$9e2c81a475b5d1b8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cBuRD.NotificationLandedEvent), null)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f60f9bb0af41c642$export$ddc928ad192d2b94), null));
    }
    constructor(...args){
        super(...args);
        $7c0ba11073bcb5f1$var$_defineProperty(this, "spacer", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c0ba11073bcb5f1$var$TopNavSpacer, {
                "data-test-id": "top-nav-spacer"
            }));
    }
}, $7c0ba11073bcb5f1$var$_defineProperty($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation, "displayName", 'StandaloneConfluenceNavigation'), $7c0ba11073bcb5f1$var$_defineProperty($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation, "propTypes", {
    isAdminScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isSpaceScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isSpaceSettingsScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    route: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
}), $7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation));


const $fe485fa379bdff14$var$getSpaceKey = (state)=>{
    const routeParams = (0, $iyEDi.getRouteParams)(state);
    return (0, $iyEDi.routerStateExists)(state) && routeParams && routeParams.spaceKey || state.meta.get('space-alias') || state.meta.get('space-key');
};
const $fe485fa379bdff14$var$mapStateToProps = (state, props)=>{
    const { location: location, matchRoute: matchRoute } = props;
    const isSpaceScreen = state.meta.get('is-space-page') === 'true' || (0, $gnnzK.isContentTypeOf)('page', state) || (0, $gnnzK.isContentTypeOf)('blogpost', state);
    //On the DELETE_SPACE_LEGACY path the space is already deleted but certain queries
    //use the spaceKey. Set spaceKey to null if on this path
    const route = matchRoute(`${location.pathname}${location.search}${location.hash}`);
    const spaceKey = route?.name === (0, $1NBp8.DELETE_SPACE_LEGACY).name ? null : $fe485fa379bdff14$var$getSpaceKey(state);
    return {
        isAdminScreen: state.meta.get('is-admin-page') === 'true',
        isSpaceScreen: isSpaceScreen,
        isSpaceSettingsScreen: state.meta.get('is-space-tool-page') === 'true',
        route: route,
        spaceKey: spaceKey
    };
};
var $fe485fa379bdff14$export$2e2bcd8739ae039 = (0, $kFqI2.connect)($fe485fa379bdff14$var$mapStateToProps)((0, $7c0ba11073bcb5f1$export$2e2bcd8739ae039));


/**
 * setupUFOGlobalErrorHandler MUST be the first thing executed before any rendering operations.
 * This ensures we catch and track any errors that occur during the app's initialization,
 * including async operations and React rendering. Moving this call later would risk missing
 * early errors.
 * it provides ufo:errors:globalCount is the count of all errors which occurred on the client all up
 */ (0, $5QpZa.default)();
const $f5e2aff200456a49$var$sessionDataPromise = (async ()=>{
    (0, $hp2SH.getApolloClient)();
    try {
        const sessionData = await (0, $aXEzU.getSessionDataAndInitializeStatsig)();
        (0, $xwvlW.initializePreloaderFnContext)(sessionData);
        return await (0, $feRZU.postProcessSessionData)(sessionData);
    } catch  {
        // For the same reasons as in the non-standalone case documented in the
        // counterpart of this file which is
        // confluence/packages/confluence-frontend-server/src/index.js at the moment
        return (0, $iC5L0.getEmptySessionData)();
    }
})();
const $f5e2aff200456a49$var$translationPromise = (0, $bLJr5.loadTranslation)((0, $7RVQB.lazyLanguage));
Promise.all([
    $f5e2aff200456a49$var$sessionDataPromise,
    $f5e2aff200456a49$var$translationPromise
]).then(([sessionData])=>{
    const browserNotSupportedCheck = (0, $2DVQX.coreBrowserNotSupported)();
    // the only requirement for BrowserNotSupported to render is the translationPromise
    if (browserNotSupportedCheck) {
        // the monolith attaches this id to the body here: confluence-core/confluence-webapp/src/main/webapp/decorators/main.vmd:62
        const documentBody = document.getElementById('com-atlassian-confluence');
        // eslint-disable-next-line react/no-deprecated
        return void (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9j59h.BrowserNotSupportedLoader), null), documentBody);
    }
    (0, $7LuKf.initialization)(sessionData);
    (0, $8bee1fe38b9eef04$export$ed04e7f6ba662aee)();
    (0, $d4f95b5cede9219f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6baa9171970034d$export$11eb671888ed6e7d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fe485fa379bdff14$export$2e2bcd8739ae039), {
            apolloClient: (0, $hp2SH.getApolloClient)(),
            location: location,
            matchRoute: matchRoute
        }))), 'ui-global-sidebar-section', true);
});
 }, ["7EorR","3rir4","CoGBw","eiF7i","aZinD","hhss7","ffEVr","Wowvf","kjZZD","6wr18"]);

$parcel$global.rlb("3pblT")
//# sourceMappingURL=standalone-navigation-jquery3.ce82357f.js.map
